// Optional legacy sliders: keep each consumer's options and receiver unchanged.
function initThemeSlickSlider($slider, options) {
  if ($slider.length && typeof $slider.slick === 'function') {
    $slider.slick(options);
  }
}

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Free Gift Product
  $(document).ready(function(){

      if ($('.option_selected-js').hasClass('add_gift-js')) {
        $('.gift-input--js').prop("disabled", false);
      }
      else {
        $('.gift-input--js').prop("disabled", true);
      }


      document.addEventListener('variant:changed', function(event) {
          var variantTitle = event.detail.variant.title;

          if ((variantTitle.includes("2") || variantTitle.includes("3")) && $('.block-swatch.main-block-js').hasClass('add_gift-js')) {
              $('.gift-input--js').prop("disabled", false);
          } else {
              $('.gift-input--js').prop("disabled", true);
          }
      });
    
       (function () {
          'use strict';

          var GIFT_PROPERTY_PATTERN = /^_free[\s_-]*gift(?:[\s_-]*\d+)?$/i;
          var GIFT_ID_INPUT_SELECTOR = 'input.freegiftId';
          var GIFT_QUANTITY = 1;
          var ORPHAN_ZERO_PRICED = true;
          var REGISTRY_KEY = 'cart-gifts:variants';
          var RELOAD_KEY = 'cart-gifts:reloads';
          var MAX_RETRIES = 2;
          var RETRY_DELAY = 800;

          var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var CART_PATH = (ROOT + 'cart').replace(/\/{2,}/g, '/').replace(/\/+$/, '');

          var knownGifts = new Set();
          var reconciling = false;
          var suppressListener = false;
          var lastPlan = null;
          var repeats = 0;
          var queue = Promise.resolve();

          try {
            JSON.parse(sessionStorage.getItem(REGISTRY_KEY) || '[]').forEach(function (id) {
              knownGifts.add(id);
            });
          } catch (e) {}

          function sleep(ms) {
            return new Promise(function (resolve) { setTimeout(resolve, ms); });
          }

          function qty(value) {
            var n = parseInt(value, 10);
            return isNaN(n) || n < 0 ? 0 : n;
          }

          function isCartPage() {
            return window.location.pathname.replace(/\/+$/, '') === CART_PATH;
          }

          function isGiftId(value) {
            var id = value == null ? '' : String(value).trim();
            return /^\d+$/.test(id) && id !== '0';
          }

          function giftIdsOf(item) {
            var props = (item && item.properties) || {};
            return Object.keys(props)
              .filter(function (key) { return GIFT_PROPERTY_PATTERN.test(key) && isGiftId(props[key]); })
              .map(function (key) { return String(props[key]).trim(); });
          }

          function remember(id) {
            if (!isGiftId(id)) return;
            id = String(id).trim();
            if (knownGifts.has(id)) return;
            knownGifts.add(id);
            try {
              sessionStorage.setItem(REGISTRY_KEY, JSON.stringify(Array.from(knownGifts)));
            } catch (e) {}
          }

          function rememberFromDom($scope) {
            ($scope || $(document)).find(GIFT_ID_INPUT_SELECTOR).each(function () {
              remember($(this).val());
            });
          }

          function rememberFromCart(cart) {
            ((cart && cart.items) || []).forEach(function (item) {
              giftIdsOf(item).forEach(remember);
            });
          }

          function postJSON(url, payload, attempt) {
            attempt = attempt || 0;
            return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            }).then(function (res) {
              if (res.ok) return res.json();
              if (res.status >= 500 && attempt < MAX_RETRIES) {
                return sleep(RETRY_DELAY).then(function () { return postJSON(url, payload, attempt + 1); });
              }
              throw new Error('Cart request failed (' + res.status + ')');
            });
          }

          function getCart() {
            return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); });
          }

          function updateCart(updates) {
            return postJSON(ROOT + 'cart/update.js', { updates: updates });
          }

          function addToCart(items) {
            return postJSON(ROOT + 'cart/add.js', { items: items });
          }

          function isGiftLine(item, owed) {
            if (giftIdsOf(item).length > 0) return false;
            if (item.final_line_price !== 0 && item.price !== 0) return false;
            var id = String(item.variant_id);
            return knownGifts.has(id) || owed.has(id) || ORPHAN_ZERO_PRICED;
          }

          function planReconciliation(cart) {
            var items = (cart && cart.items) || [];
            var owed = new Set();

            items.forEach(function (item) {
              giftIdsOf(item).forEach(function (id) {
                remember(id);
                owed.add(id);
              });
            });

            var updates = {};
            var present = new Set();

            items.forEach(function (item) {
              if (!isGiftLine(item, owed)) return;
              var id = String(item.variant_id);
              var target = !present.has(id) && owed.has(id) ? (bioBonusQuantities.get(id) || GIFT_QUANTITY) : 0;
              present.add(id);
              if (item.quantity !== target) updates[item.key] = target;
            });

            var additions = [];
            owed.forEach(function (id) {
              if (!present.has(id)) additions.push({ id: Number(id), quantity: bioBonusQuantities.get(id) || GIFT_QUANTITY });
            });

            return { updates: updates, additions: additions, owed: owed };
          }

          function reconcile(cart) {
            if (reconciling) return Promise.resolve(cart);

            var plan = planReconciliation(cart);
            if (!Object.keys(plan.updates).length && !plan.additions.length) {
              lastPlan = null;
              repeats = 0;
              try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
              return Promise.resolve(cart);
            }

            var signature = JSON.stringify([plan.updates, plan.additions]);
            if (signature === lastPlan && ++repeats >= 2) {
              console.warn('[cart-gifts] cart will not converge', plan);
              return Promise.resolve(cart);
            }
            if (signature !== lastPlan) {
              lastPlan = signature;
              repeats = 0;
            }

            reconciling = true;
            return (plan.additions.length ? addToCart(plan.additions) : Promise.resolve(cart))
              .then(function (next) {
                return Object.keys(plan.updates).length ? updateCart(plan.updates) : next;
              })
              .then(function (next) { return next || cart; })
              .finally(function () { reconciling = false; });
          }

          function canReload() {
            if (!isCartPage()) return true;
            var used = parseInt(sessionStorage.getItem(RELOAD_KEY), 10) || 0;
            if (used >= 2) return false;
            try { sessionStorage.setItem(RELOAD_KEY, String(used + 1)); } catch (e) {}
            return true;
          }

          function publish(cart) {
            if (isCartPage()) {
              if (canReload()) window.location.reload();
              return;
            }
            suppressListener = true;
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () { suppressListener = false; }, 0);
          }

          function enqueue(task) {
            queue = queue.then(task, task).catch(function (error) {
              console.error('[cart-gifts]', error);
            });
            return queue;
          }

          function setQuantity(lineKey, quantity) {
            var updates = {};
            updates[lineKey] = qty(quantity);
            return updateCart(updates)
              .then(reconcile)
              .then(function (cart) { publish(cart); return cart; });
          }

          function sync() {
            return enqueue(function () {
              return getCart().then(function (cart) {
                rememberFromCart(cart);
                return reconcile(cart).then(function (next) {
                  if (next !== cart) publish(next);
                  return next;
                });
              });
            });
          }

          function lock($line, locked) {
            $line.toggleClass('is-updating', locked)
              .find('.quantity-selector__button, .link.main-product--true')
              .prop('disabled', locked);
          }

          function lineKeyOf($el, $line) {
            return $el.attr('data-line-id') || $line.attr('data-line-id') || '';
          }

          $(document).on('click', '.quantity-selector__button.plus, .quantity-selector__button.minus', function (event) {
            event.preventDefault();

            var $button = $(this);
            if ($button.prop('disabled')) return;

            var $line = $button.closest('.line-item');
            var $input = $line.find('.quantity-selector__input').first();
            var lineKey = lineKeyOf($button, $line);
            if (!lineKey) return;

            rememberFromDom($line);

            var current = qty($input.val());
            var next = Math.max(0, current + ($button.hasClass('plus') ? 1 : -1));
            if (next === current) return;

            $input.val(next);
            lock($line, true);

            enqueue(function () {
              return setQuantity(lineKey, next)
                .catch(function (error) { $input.val(current); throw error; })
                .finally(function () { lock($line, false); });
            });
          });

          $(document).on('click', '.link.main-product--true', function (event) {
            event.preventDefault();

            var $link = $(this);
            if ($link.prop('disabled')) return;

            var $line = $link.closest('.line-item');
            var lineKey = lineKeyOf($link, $line);
            if (!lineKey) return;

            rememberFromDom($line);
            lock($line, true);

            enqueue(function () {
              return setQuantity(lineKey, 0).finally(function () { lock($line, false); });
            });
          });

          document.documentElement.addEventListener('cart:updated', function (event) {
            if (suppressListener || reconciling) return;

            var cart = event.detail && event.detail.cart;
            if (!cart || !Array.isArray(cart.items)) return;

            rememberFromCart(cart);
            enqueue(function () {
              return reconcile(cart).then(function (next) {
                if (next !== cart) publish(next);
              });
            });
          });

          document.documentElement.addEventListener('cart:refresh', function () {
            setTimeout(function () { rememberFromDom(); }, 0);
          });

          $(function () {
            rememberFromDom();
            sync();
          });

          window.CartGifts = { sync: sync, plan: planReconciliation };
          window.checkAndAddFreeProducts = sync;
          window.cartUpdated = function (payload) {
            var updates = (payload && payload.updates) || payload || {};
            return enqueue(function () {
              return updateCart(updates)
                .then(reconcile)
                .then(function (cart) { publish(cart); return cart; });
            });
          };
        })();

 
    

  });


  $(document).ready(function(){
    const productVariantElement = document.querySelector('product-variants');
    let PreselectedVariantId = $('product-variants').attr('preselected_id');
    PreselectedVariantId = parseInt(PreselectedVariantId);
    console.log(PreselectedVariantId);
    // if (PreselectedVariantId) {
    //   productVariantElement.selectVariant(PreselectedVariantId);
    // }
    setTimeout(function () {
      if (PreselectedVariantId && productVariantElement) {
          productVariantElement.selectVariant(PreselectedVariantId);
      }
    }, 500);
  });





$(document).ready(function () {
  // Progress Bar
  // function isInViewport(theDiv) {
  // let elementTop = theDiv.offset().top;
  // let elementBottom = elementTop + theDiv.outerHeight();
  // let viewportTop = $(window).scrollTop();
  // let viewportBottom = viewportTop + window.innerHeight;
  // return elementBottom > viewportTop && elementTop < viewportBottom;
  // }
  // var animationDone = false;
  // if ($('#product-block-tested').length) {
  // $(window).on('scroll', function(){
  //   if (!animationDone) {
  //   if(isInViewport($('#product-block-tested'))) {
  //     animationDone = true;
  //     $(".circleBarProgress").each(function () {
  //       var t = $(this).find(".circleBar"),
  //           x = $(this).find(".circleBarWrapper"),
  //           i = $(this).find("span"),
  //           e = parseInt(i.text(), 10);
  //       $({ p: 0 }).animate(
  //           { p: e },
  //           {
  //               duration: 3e3,
  //               easing: "swing",
  //               step: function (e) {
  //                   x.css({background: "conic-gradient(#373737 0deg " + e + "%, #DEDEDC " + e + "%)"}), i.text(0 | e);

  //               },
  //           }
  //       );
  //     });
  //   }
  // }
  // });
  // }

 

   function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top;
      let elementBottom = elementTop + theDiv.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
      }
      var animationDone = false;
      if ($('.pro_vid_img_sec').length) {
      $(window).on('scroll', function(){
        if (!animationDone) {
        if(isInViewport($('.pro_vid_img_sec'))) {
          animationDone = true;
          $(".circleBarProgress").each(function () {
            var t = $(this).find(".circleBar"),
                x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e = parseInt(i.text(), 10);
            $({ p: 0 }).animate(
                { p: e },
                {
                    duration: 3e3,
                    easing: "swing",
                    step: function (e) {
                        x.css({background: "conic-gradient(#FFFFFF  0deg,  #a54c4d " + e + "%, #fff  " + e + "%)"}), i.text(0 | e);
                         
                    },
                }
            );
          });
        }
      }
      });
      }
  
  
  // Video slider
  
  initThemeSlickSlider($('.instafeef_video_list'), {
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    infinite: true, // Enable infinite looping
    dots:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

 // Function to handle the play/pause functionality
  function toggleVideo(videoElement, parentItem) {
    if (videoElement.paused) {
      videoElement.play().catch(function(error) {
        console.error('Error attempting to play the video:', error);
        alert('Sorry, there was an error playing the video.');
      });
      parentItem.addClass('active');
    } else {
      videoElement.pause();
      parentItem.removeClass('active');
    }
  }

  // Function to pause all other videos
  function pauseAllOtherVideos(currentVideo) {
    const videos = $('.instafeef_video_list video');
    videos.each(function() {
      const videoParent = $(this).parents('.video_items');
      if (this !== currentVideo) {
        if (!this.paused) {
          this.pause();
        }
        videoParent.removeClass('active');
      }
    });
  }

  // Click event for the video element
  $('.instafeef_video_list video').click(function() {
    const currentVideo = this;
    const parentItem = $(this).parents('.video_items');
    
    // Pause all other videos and remove 'active' class from their parent elements
    pauseAllOtherVideos(currentVideo);
    
    // Toggle playback of the current video
    toggleVideo(currentVideo, parentItem);
  });

  
    $('.instafeef_video_list .instafeed_hover').click(function() {
    const parentItem = $(this).parents('.video_items');
    const currentVideo = parentItem.find('video')[0];
    if (currentVideo) {
      // Pause all other videos
      pauseAllOtherVideos(currentVideo);
      
      // Toggle playback of the current video
      toggleVideo(currentVideo, parentItem);
    }
  });


// Custom accordion
  if (window.matchMedia("(min-width: 1200px)").matches) {
$('.left_banner_acc').hover(
    function() {

          // Left banner changes
          $(this).attr('class', 'left_banner_acc max-w-[65%] pt-[18px] pb-6 px-[22px] overflow-hidden bg-bgPrimary lg:rounded-[30px] rounded-[20px] relative lg:pt-9 lg:px-6 lg:pb-8 lg:mb-0 mb-2 transition-[max-width,max-height] duration-[400ms] flex-1');
          $(this).find('.left_banner_details_inner').attr('class','left_banner_details_inner max-w-[50%] transition-[width] duration-[400ms]');
          $(this).find('.left_banner_icon_list').attr('class','left_banner_icon_list opacity-1 lg:mb-0 mb-40 flex flex-row gap-6 transition-[opacity] duration-[600ms]');
          $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
          

          // Right banner changes

          $(this).siblings('.right_banners').attr('class', 'right_banners max-w-[35%] flex flex-col gap-2 lg:grid lg:grid-cols-4 lg:grid-rows-4 lg:gap-4 transition-[max-width] duration-[400ms] flex-1')
          $(this).siblings('.right_banners').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-0');
          $(this).siblings('.right_banners').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-0');


          // Right banner 3 changes
          $(this).siblings('.right_banners').find('.right_banner_2_heading').css('width', '100%');

 },
  
    function() {
        // Left banner Class Changes
          $(this).attr('class', 'left_banner_acc max-w-[40%] pt-[18px] pb-6 px-[22px] overflow-hidden lg:rounded-[30px] rounded-[20px] relative lg:pt-9 lg:px-6 lg:pb-8 lg:mb-0 mb-2 transition-[max-width,max-height] duration-[400ms] flex-1');
          $(this).find('.left_banner_details_inner').attr('class','left_banner_details_inner max-w-[200px] transition-[width] duration-[400ms]');
          $(this).find('.left_banner_icon_list').attr('class','left_banner_icon_list opacity-0 lg:mb-0 mb-40 flex flex-row gap-6 transition-[opacity] duration-[600ms]');
          $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

          //Right banner changes
          $(this).siblings('.right_banners').attr('class', 'right_banners max-w-[60%] flex flex-col gap-2 lg:grid lg:grid-cols-4 lg:grid-rows-4 lg:gap-4 transition-[max-width] duration-[400ms] flex-1');
          $(this).siblings('.right_banners').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-100');
          $(this).siblings('.right_banners').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-100');

        // Right banner 3 changes
          $(this).siblings('.right_banners').find('.right_banner_2_heading').css('width', '50%');
      
      

}
    
    
);


  $('.right_banner_1').hover(
    function() {
      
      // Right banner-1 changes
      $(this).attr('class','right_banner_1 h-[calc(73.5px*4+16px*3)] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_1_other').attr('class','right_banner_1_other opacity-100');
      $(this).find('.right_banner_1_expand_text').attr('class','right_banner_1_expand_text opacity-0 hidden');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      
      // Right banner 2 changes
      $(this).siblings('.right_banner_2').find('.right_banner_header').attr('class','right_banner_header flex-row flex lg:items-start items-center lg:mb-0 mb-4');


      // Right banner 3 changes
     $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-[calc(50%+8px)] max-w-[calc(50%-8px)] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
  },
  
    function() {
       // Right banner-1 changes
      $(this).attr('class','right_banner_1 h-[100%] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_1_other').attr('class','right_banner_1_other opacity-0');
      $(this).find('.right_banner_1_expand_text').attr('class','right_banner_1_expand_text opacity-100');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      

      // Right banner 2 changes
       $(this).siblings('.right_banner_2').find('.right_banner_header').attr('class','right_banner_header flex lg:items-start items-center lg:mb-0 mb-4');
      
      // Right banner 3 changes
      $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
 
  }
        
);


    $('.right_banner_2').hover(
    function() {
      
      // Right banner-2 changes
      $(this).attr('class','right_banner_2 h-[calc(73.5px*4+16px*3)] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_2_other').attr('class','right_banner_2_other opacity-100');
      $(this).find('.right_banner_2_expand_text').attr('class','right_banner_2_expand_text opacity-0 hidden');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      

      // Right banner 3 changes
     $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0  max-w-[calc(50%-8px)] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
  },
  
    function() {
       // Right banner-1 changes
      $(this).attr('class','right_banner_2 h-[100%] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_2_other').attr('class','right_banner_2_other opacity-0');
      $(this).find('.right_banner_2_expand_text').attr('class','right_banner_2_expand_text opacity-100');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      
      // Right banner 3 changes
      $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
 
  }
        
);

    $('.right_banner_3').hover(
    function() {
      
      // Right banner 3 changes
        $(this).attr('class','right_banner_3 max-h-[calc(100%+36.75px)] !h-[calc(100%+36.75px)] lg:rounded-[24px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
        $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

      // Right banner 1 changes
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').attr('class','right_banner_1 h-[calc(73.5px*1.5+16px)] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_heading').css('width','100%');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-0');

      // Right banner 2 changes
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').attr('class','right_banner_2 h-[calc(73.5px*1.5+16px)] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_heading').css('width','70%');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-0');

    },
  
    function() {
      // Right banner 3 changes
        $(this).attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
        $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

      // Right banner 1 changes
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').attr('class','right_banner_1 h-[100%] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_heading').css('width','100%');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-100');
  
      // Right banner 2 changes
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').attr('class','right_banner_2 h-[100%] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_heading').css('width','50%');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-100');

      
  }
        
);
  }
  else{
    $('.banner-accordion-item').click(function() {
      $(this).toggleClass('active');
      $(this).find('.banner_accordion-content').slideToggle();
    });
  }
  

    // Custom testimonial 2
$(document).ready(function(){
  initThemeSlickSlider($('.custom-testimonial-slider-inner'), {
    slidesToShow:3,
    slidesToScroll: 1,
    infinite: false,
    dots:true,
    arrows:false,
    responsive: [
       {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
  
   // Featured with collection
  var $slider1 = $(".featured-collection-slider");

  initThemeSlickSlider($slider1, {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,
    infinite: true, // Enable infinite looping
    swipeToSlide: true,
    dots:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  var $slider = $(".result_slider");
  var $multicolumnProgressBar = $(".multicolumn_progress__bar");
  var $progressBarLabel = $(".slider__label");

  // Set initial background size and aria-valuenow
  $multicolumnProgressBar
    .css("background-size", "2% 100%")
    .attr("aria-valuenow", 2);

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    if (calc === 0) {
      $multicolumnProgressBar
        .css("background-size", "2% 100%")
        .attr("aria-valuenow", 2); // Set background size to 2% if next slide is the first one
    } else {
      $multicolumnProgressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    }

    $progressBarLabel.text(calc + "% completed");
  });

  initThemeSlickSlider($slider, {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,

    infinite: true, // Enable infinite looping
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 741,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  // Footer item Toggle
  // if (window.matchMedia("(max-width: 999px)").matches) {
  //   $(".footer__item--links .footer__item-title").click(function () {
  //     $(this).siblings(".footer__item-content").slideToggle();
  //     $(this).parents(".footer__item").toggleClass("active");
  //   });
  // }

  // Product FAQ
  $(".faq-question").click(function () {
    $(this)
      .siblings()
      .slideToggle()
      .parents(".product-faq-item")
      .toggleClass("active");
    $(this)
      .parents(".product-faq-item")
      .siblings()
      .removeClass("active")
      .find(".faq-answer")
      .slideUp();
  });


   //DEFAULT COLLAPSE JAVASCRIPT START
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("quia-collapsed").attr("aria-expanded","false");
       }
     });
    }
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("quia-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("quia-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
});

// Cart Drawer countdown timer js start

// function setCookie(name, value, days) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// function getCookie(name) {
//     const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }

// if (getCookie('timer') > new Date().getTime()) {
//     var time = getCookie('timer');
//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//                 var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// } else {
//     // Set timer for 1 hour, 59 minutes, and 58 seconds
//     var time = new Date().getTime() + (1 * 60 * 60 * 1000) + (59 * 60 * 1000) + (58 * 1000);
//     document.cookie = 'timer=' + time + '; path=/; domain=quiabeauty.com; secure=true; expires=' + new Date(new Date().getTime() + 3600000 * 24).toUTCString();

//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//                 var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// }

// function setCookie(name, value, days) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// function getCookie(name) {
//     const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }

// function getUserTimeZoneOffset() {
//     // Get the user's time zone offset in minutes
//     return new Date().getTimezoneOffset();
// }

// if (getCookie('timer') > new Date().getTime()) {
//     var time = getCookie('timer');
//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//         var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// } else {
//     // Get the current time in the user's local time zone
//     var currentTime = new Date();

//     // Calculate the time until midnight
//     var midnight = new Date(currentTime);
//     midnight.setHours(24, 0, 0, 0); // Set to 12:00 AM of the next day

//     // Calculate the time remaining until midnight (in milliseconds)
//     var timeRemaining = midnight.getTime() - currentTime.getTime();

//     // Save the adjusted timer value in the cookie
//     document.cookie = 'timer=' + (currentTime.getTime() + timeRemaining) + '; path=/; domain=quiabeauty.com; secure=true; expires=' + new Date(currentTime.getTime() + timeRemaining + 3600000 * 24).toUTCString();

//     var timer = setInterval(function() {
//         var left = timeRemaining - (new Date().getTime() - currentTime.getTime());
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//         var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// }




// Cart Drawer countdown timer js end


const block = document.querySelectorAll(".block");

const options = {
  threshold: 0.5, // Trigger when 50% of the element is visible
};

const observer = new IntersectionObserver(function (entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      let item = entry.target;
      let numElement = item.querySelector(".num");
      let num = parseInt(numElement.innerText);
      let count = 0;
      let time = 2000 / num;
      let circle = item.querySelector(".desktop-svg");
      let mobCircle = item.querySelector(".mobile-svg");
      const counterInterval = setInterval(() => {
        if (count == num) {
          clearInterval(counterInterval);
        } else {
          count += 1;
          numElement.innerText = count;
        }
      }, time);
      circle.style.strokeDashoffset = 503 - 503 * (num / 100);
      mobCircle.style.strokeDashoffset = 270 - 270 * (num / 100);
      let dots = item.querySelector(".dots");
      dots.style.transform = `rotate(${360 * (num / 100)}deg)`;
      if (num == 100) {
        dots.style.opacity = 0;
      }
      observer.unobserve(item); // Stop observing once animation starts
    }
  });
}, options);

block.forEach((item) => {
  observer.observe(item);
});

$(document).ready(function () {
  $(document).on("click", ".product-custom-varaint .block-swatch", function () {
    var variantChange = $(this).find(".block-swatch__radio").data("id");
    $(this).find(".block-swatch__radio").addClass("active");
    $(this).siblings().find(".block-swatch__radio").removeClass("active");
    var variantPrice = $(this).find(".block-swatch__radio").data("price");
    $(this)
      .parents(".product-pair")
      .find(".pair-product-add_to_cart_text span")
      .text(variantPrice);
    var variantDataId = $(this)
      .parents(".product-pair")
      .find(".ajax-add-to-cart")
      .attr("data-variantId", variantChange);
  });

$(document).on("click", ".ajax-add-to-cart", function () {
  var ajaxVariantID = $(this).attr("data-variantId");
  addToCartJS(1, ajaxVariantID, $(this));
});

function addToCartJS(qty, variantID, btn) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      btn.find('.pair-product-add_to_cart_text').html("added");
    }
  };
  var data = JSON.stringify({ quantity: qty, id: variantID });
  xhr.send(data);
}


  //   $('.gallery-carousel').slick({
  //   slidesToShow: 4,
  //   dots:false,
  //   centerMode: false,
  //   infinite:true,
  //   appendArrows: $('.product-gallery_arrow'),
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 741,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         adaptiveHeight: true,
  //       },
  //     },
  //   ],
  // });

  initThemeSlickSlider($(".custom-testimonial-left-slider"), {
    slidesToShow: 1,
    dots: false,
    centerMode: false,
    infinite: true,
    asNavFor: $(".custom-testimonial-right-slider"),
    arrows: false,
  });

  initThemeSlickSlider($(".custom-testimonial-right-slider"), {
    slidesToShow: 1,
    dots: true,
    centerMode: false,
    infinite: true,
    asNavFor: $(".custom-testimonial-left-slider"),
    appendArrows: $(".testimonial-slider-arrow"),
    appendDots: $(".custom-pagination"),
  });

  initThemeSlickSlider($(".video-slider-wrapper"), {
    slidesToShow: 4,
    dots: false,
    centerMode: true,
    centerPadding: "7%", // Adjust this value as needed for 20-30% visibility
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1351,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: "7%", // Adjust this value as needed for 20-30% visibility
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "12%", // Adjust this value as needed for 20-30% visibility
        },
      },
      {
        breakpoint: 543,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "10%", // No need for centerPadding if centerMode is false
        },
      },
    ],
  });

 
});

// $(document).ready(function () {
//   $("#shopify-section-sections--17810013585628__image_with_content_pPaxJi").css(
//     "opacity",
//     "0"
//   );
//   var footerTop = $("footer").offset().top - 350;
//   $(window).scroll(function () {
//     if ($(window).scrollTop() > footerTop) {
//       $(
//         "#shopify-section-sections--17810013585628__image_with_content_pPaxJi"
//       ).css("opacity", "1");
//     } else {
//       $(
//         "#shopify-section-sections--17810013585628__image_with_content_pPaxJi"
//       ).css("opacity", "0");
//     }
//   });
// });

$(document).on(
  "click",
  ".purchase-details__buttons .product-form__add-button",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    $this.find(".add-icon").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          if (!document.getElementById("mini-cart").open == true) {
            document.getElementById("mini-cart").open = true;
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 500);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
        },
      });
    }
  }
);

$(document).on(
  "click",
  ".product-item__cta-wrapper .product-item__cta",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    $this.find(".add-icon").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          if (!document.getElementById("mini-cart").open == true) {
            document.getElementById("mini-cart").open = true;
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 500);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
        },
      });
    }
  }
);

$(document).ready(function () {
  
  // var interval;
  // interval = setInterval(function () {
  //    if ($(".mini-cart__recommendations-list.slick-initialized").length <= 0) {

  //       var $slider = $('.mini-cart__recommendations-list');
  //   var $progressBar = $('.progress__bar, .progress__bar_item');
  //   var $progressBarLabel = $('.slider__label');

  //   // Set initial background size and aria-valuenow
  //   $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

  //   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //     var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

  //     if (calc === 0) {
  //       $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
  //     } else {
  //       $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  //     }

  //     $progressBarLabel.text(calc + '% completed');
  //   });

       
  //       $slider.slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false
  //     });
  //   }
  // }, 500);


$(document).on('change', '.rc-radio__input', function() {
    var subscribePrice;
    if ($('.rc-radio__input[value="subscription"]:checked').length > 0) {
        subscribePrice = $(this).siblings('.rc-radio__label').find('.rc-radio__price').text();
        $('.product-form__add-button').find('.price').text(subscribePrice);
    } else {
        oneTimeText = $(this).siblings('.rc-radio__label').text();
        oneTimePrice = oneTimeText.replace('One-time purchase', '').trim(); 
        $('.product-form__add-button').find('.price').text(oneTimePrice);
    }
});

 if ($('.template--product').length > 0) {
  var intervalId = setInterval(function () {
    if (document.location.href.includes("selling_plan")) {
    console.log("Interval start");

    if ($('.rc-template__radio').length > 0) {
       var subscribePrice = $('.rc-radio__input[value="subscription"] + .rc-radio__label .rc-radio__price').text();
        console.log(subscribePrice);
        $('.product-form__add-button').find('.price').text(subscribePrice);       
          clearInterval(intervalId);   
      console.log("Interval cleared");
    }

        setTimeout(function() {
          clearInterval(intervalId);
          console.log("Time Out");
        }, 5000);
      
      }
  }, 100);

 }







// $('.block-swatch__radio__cusotm').change(function(){
//   var dataPrice = $(this).siblings('.block-swatch__item__custom').find('.large-title').text(); 
//     $(this).parents('.product__info').find('.product-custom-price').text(dataPrice);

// });



 // $('.product-icon-volume').click(function(){
 //      var activeVideo = $('.video-active video')[0];
 //      if (activeVideo) {
 //        activeVideo.muted = !activeVideo.muted;
 //        $(this).toggleClass("volume-muted", activeVideo.muted);
 //      }
 //  });
});


 // function playPause(videoId, buttonId) {
 //    var myVideo = document.getElementById(videoId);
 //    var $button = $("#" + buttonId);

 //    // Pause all other videos
 //    $('video').not(myVideo).each(function() {
 //      this.pause();
 //      var otherButtonId = $(this).siblings(".video-control").attr('id');
 //      $("#" + otherButtonId).removeClass("btnhide");
 //      $("#" + otherButtonId).parents('.popup-video').removeClass('video-active');
 //      $("#" + otherButtonId).parents('body').removeClass('video-popup-active');
 //    });

 //    if (myVideo.paused) {
 //      myVideo.play();
 //    } else {
 //      myVideo.pause();
 //    }

 //    // Toggle class on the current button
 //    $button.toggleClass("btnhide");
 //    $button.parents('.popup-video').addClass('video-active');
 //    $button.parents('body').addClass('video-popup-active');
 //  }

 //  function videoClose() {

 //      var activeVideo = $('.video-active video')[0]; // Get the active video element
 //      if (activeVideo) {
 //        activeVideo.pause(); // Pause the active video
 //        var activeButtonId = $(activeVideo).siblings(".video-control").attr('id');
 //        $("#" + activeButtonId).removeClass("btnhide"); // Remove "btnhide" class from the button associated with the active video
 //      }
 //      $('body').removeClass('video-popup-active');
 //      $('.popup-video').removeClass('video-active');

 //  }


// Flicity slider counter
    var slides = document.querySelectorAll('.product__media-item');
    var sliderWrapper = document.querySelector('.product__media-list');
    var currentSlide = 0;
    var totalSlides = slides.length;
    var startX, currentX, xOffset = 0;
    var isDragging = false;

function showSlide(index) {
      if (index >= 0 && index < totalSlides) {
        currentSlide = index;
        // sliderWrapper.style.transform = 'translateX(-' + (100 * currentSlide) + '%)';
        updateSlideCount();
      }
    }

$('.template-wrapping-mask-b .product__media-prev-next').click(function() {
  
  
  setTimeout(function() {
  updateSlideCount();
  }, 200);

});



  function updateSlideCount(){
     var curSlide = $('.template-wrapping-mask-b .product__media-prev-next').siblings('.dots-nav').find('.dots-nav__item[aria-current="true"]').data('counter');
      var totalSlide = $('.dots-nav').data('slideitem');
      $('.template-wrapping-mask-b .product__media-prev-next').siblings('.slider-container').find('#slider-counter').text(`${curSlide}/${totalSlide}`)
  }
  function handleDragStart(event) {
      isDragging = true;
      startX = event.clientX || event.touches[0].clientX;
    }
    function handleDragMove(event) {
      if (!isDragging) return;
      currentX = event.clientX || event.touches[0].clientX;
      xOffset = startX - currentX;
      // sliderWrapper.style.transform = 'translateX(-' + (100 * currentSlide + xOffset / window.innerWidth * 100) + '%)';
    }
    function handleDragEnd(event) {
      setTimeout(function() {
  updateSlideCount();
  }, 200);
      // isDragging = false;
//       var threshold = window.innerWidth / 4;
//       if (xOffset < -threshold && currentSlide < totalSlides - 1) {
//         showSlide(currentSlide + 1);
//       } else if (xOffset > threshold && currentSlide > 0) {
//         showSlide(currentSlide - 1);
//       } else {
// console.log(currentSlide);
//         showSlide(currentSlide);
//       }
    }
if (sliderWrapper != null) {
    sliderWrapper.addEventListener('mousedown', handleDragStart);
    sliderWrapper.addEventListener('mousemove', handleDragMove);
    sliderWrapper.addEventListener('mouseup', handleDragEnd);
    sliderWrapper.addEventListener('mouseleave', handleDragEnd);
    sliderWrapper.addEventListener('touchstart', handleDragStart);
    sliderWrapper.addEventListener('touchmove', handleDragMove);
    sliderWrapper.addEventListener('touchend', handleDragEnd);
}
    
     setTimeout(function() {
  updateSlideCount();
  }, 200);

// Change flag based on country
   const countryMapping = {
            "US": "United States",
            "CA": "Canada",
            "GB": "United Kingdom",
            "AU": "Australia",
            "DE": "Germany",
            "IT": "Italy",
            "IE": "Ireland",
            "NZ": "New Zealand",
            "CH": "Switzerland",
            "NL": "Netherlands",
            "DK": "Denmark",
            "BE": "Belgium",
            "AE": "United Arab Emirates",
            "SE": "Sweden",
            "IL": "Israel",
            "SG": "Singapore",
            "ES": "Spain",
            "AT": "Austria",
            "MT": "Malta",
            "BD": "Bangladesh",
        };

$.get("https://ipinfo.io", function(response) { 

    var countryCode = response.country.toLowerCase();
   const countryName = countryMapping[ response.country] || response.country;
    var flagIcon = countryName+ `<span class="flag-icon flag-icon-${countryCode}"></span>`;
    $(".country1").html(flagIcon);
}, "jsonp");


$(document).ready(function(){
  $('.popup_title').click(function(){
    $(this).parents('.popup_wrapper').addClass('active');
  });

   $('.popup_close').click(function(){
    $(this).parents('.popup_wrapper').removeClass('active');
     
  });

  
});


// var carouselStatus = document.querySelector('#slider-counter');

//   // var flkty = new Flickity('.product__media-list', {
//   //   cellAlign: 'left',
//   //   contain: true
//   // });

// function updateStatus() {
//   var slideNumber = flkty.selectedIndex + 1;
//   carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
// }
// updateStatus();

// flkty.on( 'select', updateStatus );



   $(document).on("click", ".product-video-block .video-control", function() {

       var clickedControl = $(this).parents('.video-item');
       var clickedVideo = clickedControl.find('video')[0];
       var videoHtml = clickedControl.find('.show').html();
       // Move the video to the main popup
       $('.main-product-popup').html(videoHtml);

       // Pause all other videos
       $('.popup-video video').not(clickedVideo).each(function() {
           this.pause();
           $(this).siblings('.video-control').removeClass('btnhide');
       });

       // Toggle play/pause and update control icon for the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo.paused) {
           mainPopupVideo.play();
           $('.main-product-popup .video-control').addClass('btnhide');
       } else {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       // Activate the main popup
       $('.main-product-popup').addClass('video-active');
       $('body').addClass('video-popup-active');
   });

     $(document).on("click", ".main-product-popup .icon-close", function() {
       // Pause and close the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.main-product-popup').removeClass('video-active');
       $('.main-product-popup').empty();
  });

   $(document).on("click", ".main-product-popup .icon-volume", function() {
   console.log("this = ", this);
   	var mainPopupVideo = $(this).parents('.main-product-popup').find('video')[0];
   	console.log("mainPopupVideo", mainPopupVideo);
   	if (mainPopupVideo) {
   		mainPopupVideo.muted = !mainPopupVideo.muted;
   		$(this).toggleClass("volume-muted", mainPopupVideo.muted);
   	}
   });

// $(document).ready(function() {
//     // Select the video elements
//     var video1 = $('#video-poster-1 video')[0];
//     var video2 = $('#video-poster-2 video')[0];
//     // Function to start playing video 1 and stop video 2
//     function playVideo1() {
//         video2.pause();
//         video2.currentTime = 0; // Optional: Reset video 2 to the start
//         video1.play();
//         setTimeout(function() {
//             playVideo2();
//         }, 4000); // Wait for 4 seconds before switching to video 2
//     }
//     // Function to start playing video 2 and stop video 1
//     function playVideo2() {
//         video1.pause();
//         video1.currentTime = 0; // Optional: Reset video 1 to the start
//         video2.play();
//         setTimeout(function() {
//             playVideo1();
//         }, 4000); // Wait for 4 seconds before switching back to video 1
//     }
//     // Start the loop with video 1
//     playVideo1();
// });
$(document).ready(function() {
    var video1 = $('#video-poster-1 video')[0];
    var video2 = $('#video-poster-2 video')[0];

    if (!video1 || !video2) return;

    function playVideo1() {
        video2.pause();
        video2.currentTime = 0;
        video1.muted = true;
        video1.play();

        setTimeout(function() {
            playVideo2();
        }, 4000);
    }
    function playVideo2() {
        video1.pause();
        video1.currentTime = 0;
        video2.muted = true;
        video2.play();

        setTimeout(function() {
            playVideo1();
        }, 4000);
    }
    playVideo1();
});

$(document).ready(function () {
  var shippingDays = 2;
  function getFormattedDate(date) {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    let day = days[date.getDay()] + ', ' + date.getDate();
    let month = monthNames[date.getMonth()];

    return `${day} ${month}`;
  }

  function addDaysToDate(date, daysToAdd) {
    let newDate = new Date(date);
    newDate.setDate(date.getDate() + daysToAdd);

    return newDate;
  }

  let todaysDate = new Date();
  let nexttwodaysdate = addDaysToDate(
    todaysDate, shippingDays);
  
  $(".deliverydate").text(" " + getFormattedDate(nexttwodaysdate));




});

// function giftAddToCart(productId) {
//     var data = {
//         items: [{
//             id: productId,
//             quantity: 1 
//         }]
//     };

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data)
//     })
//     .then(response => {
//         if (!response.ok) {
//             throw new Error('Network response was not ok ' + response.statusText);
//             location.reload();
//         }
//         return response.json();
//     })
//     .then(data => {
//         console.log('Item added to cart:');
//     })
//     .catch(error => {
//         console.error('There was a problem with the fetch operation:', error);
//     });
// }

//  document.addEventListener('addToCartButtonClicked', (e) => {
//      var inputValue = $('input[name="items[1][id]"]');

//     if (!inputValue.prop('disabled') && inputValue.length > 0) {
//         var productId = inputValue.val(); 
//         console.log('Product ID:', productId);
//         giftAddToCart(productId);
        
//     }
//  })


// $(document).ready(function() {
//     // Step 1: Fetch the current cart
//     fetch(window.Shopify.routes.root + 'cart.js')
//         .then(response => {
//             if (!response.ok) {
//                 throw new Error('Network response was not ok ' + response.statusText);
//             }
//             return response.json();
//         })
//         .then(cart => {
//             // Step 2: Check the conditions for the cart
//             if (cart.item_count === 1) {
//                 const lineItem = cart.items[0];
                
//                 // Condition 1: If the product is free (price is 0)
//                 if (lineItem.price === 0) {
//                   console.log(lineItem);
//                   removeFromCart(lineItem.id); 
//                 } 
//                 // Condition 2: If the product is not free
//                 else {
//                     const freeGiftProperty = lineItem.properties["_free gift 1"];
//                     if (freeGiftProperty) {
//                         addToCart(freeGiftProperty); // Add the free gift product
//                     }
//                 }
//             }
//         })
//         .catch(error => {
//             console.error('There was a problem with the fetch operation:', error);
//         });
// });

// // Function to remove a product from the cart
// function removeFromCart(productId) {
//     let id = productId;
//     if (typeof productId === 'object') {
//         id = `${productId.product_id}:${productId.variant_id}`;
//     }

//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ updates: { [id]: 0 } }) // Set quantity to 0 to remove
//     })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Product removed from cart:', data);
//         refreshCart();
//     })
//     .catch(error => {
//         console.error('Error removing product:', error);
//     });
// }

// // Function to add a product to the cart
// function addToCart(productId) {
//     const data = {
//         items: [{
//             id: productId,
//             quantity: 1 // Set quantity to 1
//         }]
//     };

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Product added to cart:', data);
//         refreshCart();
//     })
//     .catch(error => {
//         console.error('Error adding product:', error);
//     });
// }

// // Function to refresh the cart drawer
// function refreshCart() {
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true
//     }));
// }


  // // Triggered when an offer is added
  // document.addEventListener('candyrack-offer-added', (e) => {
    
  // })
  // document.addEventListener('candyrack-offer-removed', (e) => {
    
  // })


  // document.addEventListener('candyrack-closed', (e) => {
  //   var inputValue = $('input[name="items[1][id]"]');

  //   if (!inputValue.prop('disabled')) {
  //       var productId = inputValue.val(); 
  //       console.log('Product ID:', productId);
  //       giftAddToCart(productId);
        
  //   }
  // });


$(document).ready(function() {
  initThemeSlickSlider($('.reviews-slider-product-info'), {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768, // Example for tablet screens
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480, // Example for mobile screens
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

// SHIPPING INSURANCE JS START

// function refreshCart() {
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
// }

// $(document).ready(function () {
//     const shippingProductVariantId = "43256435114031";
//     const localStorageKey = "shipping_protection_disabled";

//     function isShippingProtectionInCart(cart) {
//         return cart.items.some(item => item.variant_id == shippingProductVariantId);
//     }

//     function addShippingProtectionToCart() {
//             $.ajax({
//                 type: "POST",
//                 url: "/cart/add.js",
//                 data: { quantity: 1, id: shippingProductVariantId },
//                 dataType: "json",
//                 success: function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//                 },
//                 error: function (error) {
//                     console.error("Error adding shipping protection:", error);
//                 }
//             });
//     }

//     function removeShippingProtectionFromCart() {
//         $.getJSON("/cart.js", function (cart) {
//             const item = cart.items.find(item => item.variant_id == shippingProductVariantId);
//             if (item) {
//                 $.ajax({
//                     type: "POST",
//                     url: "/cart/change.js",
//                     data: { quantity: 0, id: item.key },
//                     dataType: "json",
//                     success: function () {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//                     },
//                     error: function (error) {
//                         console.error("Error removing shipping protection:", error);
//                     }
//                 });
//             }
//         });
//     }

//     document.addEventListener('cart:updated', function (event) {
//       var cart = event.detail.cart;
//       console.log("updating");
//       if (!isShippingProtectionInCart(cart) && !localStorage.getItem(localStorageKey)) {
//               addShippingProtectionToCart();
//           }
//       if (cart.item_count === 1 && isShippingProtectionInCart(cart) ) {
//         removeShippingProtectionFromCart();
//       }
//     });

//     $(document).on("click", ".upcart-addons-toggle-js", async function () {
//         const $toggle = $(this).find(".styles_ToggleSwitch__");
//         const $circle = $(this).find(".styles_ToggleSwitch__circle__");
//         const $button = $(this);

//         $button.prop("disabled", true).attr("aria-busy", "true");

//         $toggle.toggleClass("styles_ToggleSwitch--active__");
//         $circle.toggleClass("styles_ToggleSwitch__circle--active__");

//         const isActive = $toggle.hasClass("styles_ToggleSwitch--active__");

//         try {
//             if (isActive) {
//                 await addShippingProtectionToCart();
//             } else {
//                 await removeShippingProtectionFromCart();
//                 localStorage.setItem(localStorageKey, true);
//             }
//         } catch (error) {
//             $toggle.toggleClass("styles_ToggleSwitch--active__");
//             $circle.toggleClass("styles_ToggleSwitch__circle--active__");
//         } finally {
//             $button.prop("disabled", false).attr("aria-busy", "false");
//         }
//     });
// });

// SHIPPING INSURANCE JS END



$(document).ready(function () {
  $('.block-swatch__radio[type="radio"]').on('change', function () {
    var selectedVariantId = $(this).attr('data-variantid');

    $('.shopify-product-form input[name="id"]').val(selectedVariantId);
  });
});

$('variant-picker input[type="radio"]').on('change', function () {

    let selectedVariant = $(this).data('variantid');

    let $stickyBtn = $('#product-sticky-btn');

    $stickyBtn.find('.sticky_atc_form input[name="id"]').val(selectedVariant);
    $('input.current-variant-id[name="id"]').val(selectedVariant);

    let variantImageSrc = $(this).closest('.block-swatch').find('.variant_image img').attr('src');
    let discountText = $(this).closest('.block-swatch').find('.variant_price_discount').text();
let variantPercentage = discountText.match(/\d+%/);

if (variantPercentage) {
    variantPercentage = variantPercentage[0]; 
} else {
    variantPercentage = ""; 
}


  $('#AddToCart').find('.varaint_price').text(variantPercentage)

    $stickyBtn.find('.button_sticky_wrapper__product-image').attr('src', variantImageSrc);
});


// $(document).on('click','.product_upsell_add', function(){
//   var $button = $(this);
//   $button.addClass('loading');
//   var dataVaraint = $(this).data('variant');
//   addUpsell(dataVaraint, $button);
// });

$(document).on('click', '.product_upsell_add', function () {
  var $button = $(this);
  $button.addClass('loading active');
  var dataVaraint = $button.data('variant');
  addUpsell(dataVaraint, $button);
  
  // remove active after some time (e.g. 1 second)
  setTimeout(function () {
    $button.removeClass('active');
  }, 1000);
});
document.documentElement.addEventListener('cart:refresh', function () {
  $('.product_upsell_add').each(function () {
    var $button = $(this);

    var variantId = $button.data('variant');

    // yahan check karo cart me item hai ya nahi
    $.getJSON('/cart.js', function(cart) {
      var exists = cart.items.some(item => item.variant_id == variantId);

      if (exists) {
         $button.text('Added');
      } else {
        $button.text('Add');
     
      }
    });
  });
});
function addUpsell(dataVaraint, $button){
  $.ajax({
    type:'post',
    url:'/cart/add.js',
    contentType:'application/json',
    dataType:'json',
    data:JSON.stringify({
      id:dataVaraint
    }),
    success:function(){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
      }));
      $('.mini-cart').prop('open',true);
         $button.removeClass('loading').text('Added');
    },
    error:function(){
      console.log('Can not add Product');
    }
  })
}




// document.addEventListener("DOMContentLoaded", function() {
//   const upsellModule = document.getElementById('up-upsell-carousel');
  
//   if (upsellModule) {
//     // Select all potential product entries within the module
//     const allProducts = upsellModule.querySelectorAll('.upcart-upsell-item-card');
//     // Select only the ones currently hidden
//     const hiddenProducts = upsellModule.querySelectorAll('.upsell_products_hide');

//     // If every product has the hide class, hide the entire module
//     if (allProducts.length === hiddenProducts.length) {
//       upsellModule.style.display = 'none';
//       console.log("hidden");
//     }
//   }
// });



  $(document).ready(function () {
    var animated = false;

    function isScrolledIntoView(elem) {
  if (!$(elem).length) {
    return false; 
  }

  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).outerHeight();

  return (elemTop <= docViewBottom) && (elemBottom >= docViewTop);
}


    function animatePercentages() {
      $('.percentage').each(function () {
        var $this = $(this);
        var targetPercentage = parseInt($this.data('percentage'));

        $({ countNum: 0 }).animate(
          { countNum: targetPercentage },
          {
            duration: 1500,
            easing: 'swing',
            step: function () {
              $this.text(Math.floor(this.countNum) + '%');
            },
            complete: function () {
              $this.text(this.countNum + '%');
            }
          }
        );
      });
    }

    $(window).on('scroll', function () {
      if (!animated && isScrolledIntoView($('.consumer_block_wrapper'))) {
        animatePercentages();
        animated = true;
      }
    });
  });



// Video slider
const swiper = typeof Swiper !== "undefined" && document.querySelector(".tried-tested-video") ? new Swiper(".tried-tested-video", {
  // Default parameters
  slidesPerView: 5,
  spaceBetween: 8,
  loop: true,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 5,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    prevEl: ".tried-tested-wrapper  .swiper-button-prev",
    nextEl: ".tried-tested-wrapper  .swiper-button-next",
  },
}) : null;


function logoSlider() {
  initThemeSlickSlider($(".as-feat-section .main-logo-section"), {
    infinite: !0,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: !1,
    autoplay: !0,
    autoplaySpeed: 2e3,
    dots: true,
    // responsive: [
    //   {
    //     breakpoint: 767,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  });
}
$(window).resize(function () {
  $(window).width() <= 750 && logoSlider();
}),
$(window).width() <= 750 && logoSlider();

(function () {
  function selectFirstOption() {
    if (window.location.search.includes("variant=")) return;

    const radios = document.querySelectorAll('.block-swatch__radio, input[name="option1"]');
    if (radios.length) {
      radios[0].checked = true;
      radios[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  document.addEventListener("DOMContentLoaded", selectFirstOption);
  window.addEventListener("pageshow", selectFirstOption);
})();


(function() {
    if (!window.location.pathname.includes('tools/recurring/login')) return;
    function applyCustomContent() {
        if (!window.location.pathname.includes('tools/recurring/login')) return;

        const config = window.RechargeCustomConfig || {
            heading: 'Request Subscription Login Link',
            subtext: 'Provide your email below which you used for purchasing the subscription. We will send a magic link to your email that will sign you in instantly.',
            placeholder: 'Your email address',
            buttonLabel: 'Send Subscription Login Link'
        };

        const $heading = $('.rc-login--header-title');
        if ($heading.length && $heading.text() !== config.heading) {
            $heading.text(config.heading);
        }

        if ($('.rc-custom-subtext').length === 0 && $heading.length) {
            $('<p class="rc-custom-subtext">' + config.subtext + '</p>')
                .insertAfter('.rc-login--header-title');
        }

        const $input = $('#rc-email');
        if ($input.length && $input.attr('placeholder') !== config.placeholder) {
            $input.attr('placeholder', config.placeholder);
        }

        const $btnSpan = $('.rc-login-form-button span');
        if ($btnSpan.length && $btnSpan.text() !== config.buttonLabel) {
            $btnSpan.text(config.buttonLabel);
        }

        const $errorMessage = $('.rc-email-error');
        if ($errorMessage.length && $errorMessage.text() !== "No subscription records found for this email.") {
            $errorMessage.text("No subscription records found for this email.");
        }

        const $container = $('.rc-login');
        if ($container.length && !$container.hasClass('ready')) {
            $container.addClass('ready');
        }

        const urlParams = new URLSearchParams(window.location.search);
        const emailParam = urlParams.get('email');
        const $emailInput = $('.rc-login-form-container input.rc-login-form-email');
        const $submitBtn = $('.rc-login-form-button');

        if (emailParam && $emailInput.length && $emailInput.val() === "") {
            $emailInput.val(emailParam);
            
            setTimeout(function() {
                if ($submitBtn.length) {
                    $submitBtn.click();
                }
            }, 50);
        }
    }

    // Run interval to catch dynamically loaded Recharge elements
    const forceContentUpdate = setInterval(function() {
        if ($('.rc-login--header-title').length) {
            applyCustomContent();
            
            const config = window.RechargeCustomConfig;
            // Stop clearing if the items are set (added check for email param to keep interval running if needed)
            const isFinished = config && 
                               $('.rc-login-form-button span').text() === config.buttonLabel && 
                               $('.rc-email-error').text() === "No subscription records found for this email." &&
                               $('.rc-login').hasClass('ready');
            
            if (isFinished) {
                clearInterval(forceContentUpdate);
            }
        }
    }, 100);
})();


// (function ($) {

//   var SEL_PRICE_CURRENT = '.pip__price--current';
//   var SEL_PRICE_COMPARE = '.pip__price--compare';

//   function formatMoney(cents) {
//     if (!cents || cents === 0) return '';
//     var dollars = cents / 100;
//     return (dollars % 1 === 0
//       ? '$' + dollars.toFixed(0)
//       : '$' + dollars.toFixed(2).replace(/0+$/, '')) + ' USD';
//   }

//   function getForm(formId) {
//     return $('#' + formId).length
//       ? $('#' + formId)
//       : $('form[action*="/cart/add"]').first();
//   }

//   // function updatePrices(sectionId, variantId, variants) {
//   //   var data = variants[variantId];
//   //   if (!data) return;
//   //   var scope = $('.custom__product__info_js').length
//   //     ? $('.custom__product__info_js')
//   //     : $(document);
//   //   scope.find(SEL_PRICE_CURRENT).text(formatMoney(data.price));
//   //   if (data.compareAtPrice && data.compareAtPrice > data.price) {
//   //     scope.find(SEL_PRICE_COMPARE).text(formatMoney(data.compareAtPrice)).show();
//   //   } else {
//   //     scope.find(SEL_PRICE_COMPARE).text('').hide();
//   //   }
//   // }
//   function updatePrices(sectionId, variantId, variants) {
//     try {
//       // 🔴 SAFE CHECK: jQuery must exist
//       if (typeof window.jQuery === "undefined") {
//         console.error("jQuery is not loaded");
//         return;
//       }

//       var $ = window.jQuery;

//       var data = variants?.[variantId];
//       if (!data) {
//         console.warn("No variant data found for:", variantId);
//         return;
//       }

//       var scope = $(".custom__product__info_js").length
//         ? $(".custom__product__info_js")
//         : $(document);

//       if (typeof SEL_PRICE_CURRENT === "undefined") {
//         console.error("SEL_PRICE_CURRENT is not defined");
//         return;
//       }

//       scope.find(SEL_PRICE_CURRENT).text(formatMoney(data.price));

//       if (
//         data.compareAtPrice &&
//         data.compareAtPrice > data.price
//       ) {
//         scope
//           .find(SEL_PRICE_COMPARE)
//           .text(formatMoney(data.compareAtPrice))
//           .show();
//       } else {
//         scope.find(SEL_PRICE_COMPARE).text("").hide();
//       }

//     } catch (err) {
//       console.error("updatePrices crashed:", err);
//     }
//   }

//   function updateFormVariant(formId, variantId) {
//     var $input = getForm(formId).find('input[name="id"]');
//     if ($input.length) $input.val(variantId).trigger('change');
//   }

//   function toggleFreebieInputs(enable) {
//     $('.vp-freebie-input').prop('disabled', !enable);
//   }

//   function initVariantPicker(config) {
//     var formId    = config.formId;
//     var sectionId = config.sectionId;
//     var variants  = config.variants;

//     var $cards = $('.custom__product__info_js [data-vp-card]');
//     if (!$cards.length) return;

//     function activate($card) {
//       $cards.removeClass('vp-card--selected');
//       $card.addClass('vp-card--selected');
//       var $radio = $card.find('.vp-radio-input');
//       $radio.prop('checked', true);
//       var variantId = $radio.val();
//       if (!variantId) return;
//       updateFormVariant(formId, variantId);
//       updatePrices(sectionId, variantId, variants);
//       toggleFreebieInputs($card.hasClass('vp-card--freebies'));
//       $(document).trigger('vp:variantChanged', [{ variantId: variantId, sectionId: sectionId }]);
//     }

//     $cards.each(function () {
//       var $card  = $(this);
//       var $radio = $card.find('.vp-radio-input');
//       if ($radio.prop('checked')) {
//         $card.addClass('vp-card--selected');
//         updateFormVariant(formId, $radio.val());
//         updatePrices(sectionId, $radio.val(), variants);
//         toggleFreebieInputs($card.hasClass('vp-card--freebies'));
//       }
//       $card.on('click', function () {
//         if ($card.hasClass('vp-card--sold-out')) return;
//         console.log("cart listener file loaded");
//         activate($card);
//       });
//     });
//   }

//   $(function () {
//     if (!window.VP) return;
//     $.each(window.VP, function (sectionId, config) {
//       initVariantPicker(config);
//     });
//   });

// })(jQuery);

(function ($) {

  var SEL_PRICE_CURRENT = '.pip__price--current';
  var SEL_PRICE_COMPARE = '.pip__price--compare';

  function formatMoney(cents) {
    if (!cents || cents === 0) return '';
    var dollars = cents / 100;
    return (dollars % 1 === 0
      ? '$' + dollars.toFixed(0)
      : '$' + dollars.toFixed(2).replace(/0+$/, '')) + ' USD';
  }

  function getForm(formId) {
    return $('#' + formId).length
      ? $('#' + formId)
      : $('form[action*="/cart/add"]').first();
  }

  // ✅ NEW: Dynamically update installment amount when variant changes
  function updateInstallments(price) {
    var $installments = $('.pip__installments[data-installment-count]');
    if (!$installments.length) return;

    $installments.each(function () {
      var count = parseInt($(this).attr('data-installment-count')) || 4;
      if (!price || count === 0) return;

      var amountCents = Math.floor(price / count); // e.g. 3900 / 4 = 975
      var dollars = amountCents / 100;             // 975 / 100 = 9.75

      // Format: $9.75 or $10 (no trailing zeros)
      var formatted = '$' + (dollars % 1 === 0
        ? dollars.toFixed(0)
        : dollars.toFixed(2));

      $(this).find('.pip__installment-amount').text(formatted);
    });
  }

  function updatePrices(sectionId, variantId, variants) {
    try {
      // 🔴 SAFE CHECK: jQuery must exist
      if (typeof window.jQuery === "undefined") {
        console.error("jQuery is not loaded");
        return;
      }

      var $ = window.jQuery;

      var data = variants?.[variantId];
      if (!data) {
        console.warn("No variant data found for:", variantId);
        return;
      }

      var scope = $(".custom__product__info_js").length
        ? $(".custom__product__info_js")
        : $(document);

      if (typeof SEL_PRICE_CURRENT === "undefined") {
        console.error("SEL_PRICE_CURRENT is not defined");
        return;
      }

      scope.find(SEL_PRICE_CURRENT).text(formatMoney(data.price));

      if (
        data.compareAtPrice &&
        data.compareAtPrice > data.price
      ) {
        scope
          .find(SEL_PRICE_COMPARE)
          .text(formatMoney(data.compareAtPrice))
          .show();
      } else {
        scope.find(SEL_PRICE_COMPARE).text("").hide();
      }

      // ✅ NEW: Update installment amount dynamically on variant change
      updateInstallments(data.price);

    } catch (err) {
      console.error("updatePrices crashed:", err);
    }
  }

  function updateFormVariant(formId, variantId) {
    var $input = getForm(formId).find('input[name="id"]');
    if ($input.length) $input.val(variantId).trigger('change');
  }

/* ===== BUGFIX (free product duplicate on "Buy 1") =====
   ORIGINAL CODE COMMENTED OUT BELOW — restore this block to revert.
      Bug: the single-freebie selector matched by [value], but a freebie's id value
         appears on BOTH its items[][id] AND its properties[_free gift N] input, so
            $targetInput contained 2 elements and the .next().next() walk spilled into the
               NEXT freebie (the BOGO mask), adding a 2nd mask to the cart on the "Buy 1" option.

               function toggleFreebieInputs(enable, hasSingleFreebie, singleFreebieId) {
                 if (enable) {
                     $('.vp-freebie-input').prop('disabled', false);

                       } else if (hasSingleFreebie && singleFreebieId) {
                           $('.vp-freebie-input').prop('disabled', true);

                               const $targetInput = $(`.vp-freebie-input[value="${singleFreebieId}"]`);
                                   $targetInput.prop('disabled', false);
                                       $targetInput.next('.vp-freebie-input').prop('disabled', false);
                                           $targetInput.next('.vp-freebie-input').next('.vp-freebie-input').prop('disabled', false);

                                             } else {
                                                 $('.vp-freebie-input').prop('disabled', true);
                                                   }
                                                   }
                                                      ===== END ORIGINAL ===== */

                                                      // ===== NEW CODE (fix) =====
                                                      // Match ONLY the items[][id] input (not the properties[] input that shares the
                                                      // same value) so $idInput is a single element; then enable exactly that freebie's
                                                      // trio: id + quantity + property. This stops the sibling-walk leaking into the
                                                      // next freebie. To revert: delete this function and uncomment the original above.
                                                      function toggleFreebieInputs(enable, hasSingleFreebie, singleFreebieId) {
                                                        if (enable) {
                                                            $('.vp-freebie-input').prop('disabled', false);

                                                              } else if (hasSingleFreebie && singleFreebieId) {
                                                                  $('.vp-freebie-input').prop('disabled', true);

                                                                      var $idInput = $('.vp-freebie-input[name="items[][id]"][value="' + singleFreebieId + '"]').first();
                                                                          $idInput
                                                                                .add($idInput.next('.vp-freebie-input'))
                                                                                      .add($idInput.next('.vp-freebie-input').next('.vp-freebie-input'))
                                                                                            .prop('disabled', false);

                                                                                              } else {
                                                                                                  $('.vp-freebie-input').prop('disabled', true);
                                                                                                    }
                                                                                                    }
                                                                                                    // ===== END NEW CODE =====

  function initVariantPicker(config) {
    var formId    = config.formId;
    var sectionId = config.sectionId;
    var variants  = config.variants;

    var $cards = $('.custom__product__info_js [data-vp-card]');
    if (!$cards.length) return;

    function activate($card) {
      $cards.removeClass('vp-card--selected');
      $card.addClass('vp-card--selected');
      var $radio = $card.find('.vp-radio-input');
      $radio.prop('checked', true);
      var variantId = $radio.val();
      if (!variantId) return;
      updateFormVariant(formId, variantId);
      updatePrices(sectionId, variantId, variants);
      toggleFreebieInputs(
      $card.hasClass('vp-card--freebies'),
      $card.data('has-single-freebie'),
      $card.data('single-bie-id')
    );
      $(document).trigger('vp:variantChanged', [{ variantId: variantId, sectionId: sectionId }]);
    }

    $cards.each(function () {
      var $card  = $(this);
      var $radio = $card.find('.vp-radio-input');
      if ($radio.prop('checked')) {
        $card.addClass('vp-card--selected');
        updateFormVariant(formId, $radio.val());
        updatePrices(sectionId, $radio.val(), variants);
        toggleFreebieInputs(
        $card.hasClass('vp-card--freebies'),
        $card.data('has-single-freebie'),
        $card.data('single-bie-id')
      );
      }
      $card.on('click', function () {
        if ($card.hasClass('vp-card--sold-out')) return;
        console.log("cart listener file loaded");
        activate($card);
      });
    });
  }

  $(function () {
    if (!window.VP) return;
    $.each(window.VP, function (sectionId, config) {
      initVariantPicker(config);
    });
  });

})(jQuery);

(function () {
  var overlay = document.getElementById('luxeDrawerOverlay');
  var drawer = document.getElementById('luxeShadeDrawer');
  var triggerBtn = document.getElementById('lpiDrawerTrigger');
  var closeBtn = document.getElementById('luxeDrawerClose');
  var submitBtn = document.getElementById('luxeDrawerSubmit');
  var $carouselTrack = $('.luxe-drawer-carousel-track');

  if (!drawer || !triggerBtn) return;

  // 1. Initialize Slick Slider with custom configuration
  if ($carouselTrack.length && typeof $.fn.slick === 'function') {
    $carouselTrack.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,         // Required for seamless left/right peeking on first/last items
      arrows: false,          
      dots: false,
      centerMode: true,      
      centerPadding: '80px',  
      adaptiveHeight: false
    });

    // 2. Slider Swipe/Change -> Update Pills & Main PDP Selection
    $carouselTrack.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // Target the real slide element using data-slick-index to bypass infinite clones
    var $nextSlideEl = $carouselTrack.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
    
    // Fallback detection logic if nextSlide is an appended clone element
    if (!$nextSlideEl.length) {
      $nextSlideEl = $(slick.$slides[nextSlide]);
    }

    var shadeName = $nextSlideEl.find('.luxe-drawer-slide-card').data('slide-shade');
    
    if (shadeName) {
        // Highlight the corresponding top row pill
        document.querySelectorAll('.luxe-drawer-swatch-pill-wrap').forEach(function(pill) {
          if (pill.dataset.shade === shadeName) {
            pill.classList.add('is-active');
          } else {
            pill.classList.remove('is-active');
          }
        });

        // Synchronize back down to core layout storefront buttons
        var matchingMainSwatch = document.querySelector('.lpi__swatch[data-shade="' + shadeName + '"]');
          if (matchingMainSwatch && !matchingMainSwatch.classList.contains('lpi__swatch--active')) {
            matchingMainSwatch.click();
          }
        }
    });
  }

  // 3. Open Drawer -> Recalculate Slick Width positions and align active index
  triggerBtn.addEventListener('click', function() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden'; 
    
    // Critical: Prevents Slick tracking containers from rendering flat or broken inside hidden elements
    if (typeof $.fn.slick === 'function') {
      $carouselTrack.slick('setPosition');
    }
    
    syncDrawerFromMainLayout();
  });

  // 4. Close Drawer Setup
  function closeLuxeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn.addEventListener('click', closeLuxeDrawer);
  overlay.addEventListener('click', closeLuxeDrawer);
  submitBtn.addEventListener('click', closeLuxeDrawer);

  // 5. Direct Slider Nav matching active structural nodes
  function updateDrawerActiveCarousel(activeShade) {
  if (typeof $.fn.slick !== 'function') return;
  
  var slideIndex = -1;
  // Look through native slick wrapper tracks for the clean slide item index
  $carouselTrack.find('.luxe-drawer-slide-card').each(function() {
    var $parentSlide = $(this).closest('.slick-slide');
    // Ensure we do not target an active cloned duplicated slide panel
    if ($parentSlide.length && !$parentSlide.hasClass('slick-cloned') && $(this).data('slide-shade') === activeShade) {
      slideIndex = $parentSlide.data('slick-index');
      return false;
    }
  });

  if (slideIndex !== -1) {
    $carouselTrack.slick('slickGoTo', parseInt(slideIndex, 10));
  }
}

  // 6. Pre-select target states based on main active selection
  function syncDrawerFromMainLayout() {
    var activeMainSwatch = document.querySelector('.lpi__swatch.lpi__swatch--active');
    if (activeMainSwatch) {
      var currentShade = activeMainSwatch.dataset.shade;
      drawer.querySelectorAll('.luxe-drawer-swatch-pill-wrap').forEach(function(pill) {
        if (pill.dataset.shade === currentShade) {
          pill.classList.add('is-active');
        } else {
          pill.classList.remove('is-active');
        }
      });
      updateDrawerActiveCarousel(currentShade);
    }
  }

  // 7. Pill Swatch Click -> Change Slider Position
  drawer.querySelectorAll('.luxe-drawer-swatch-pill-wrap').forEach(function(pill) {
    pill.addEventListener('click', function() {
      drawer.querySelectorAll('.luxe-drawer-swatch-pill-wrap').forEach(function(p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');
      
      var selectedShade = pill.dataset.shade;
      updateDrawerActiveCarousel(selectedShade);
    });
  });

  // // 8. Native Offer card radio layout tracking code
  // document.querySelectorAll('.lpi__offer-card').forEach(function (card) {
  //   card.addEventListener('click', function () {
  //     var list = card.closest('.lpi__offer-list');
  //     if (!list) return;
  //     list.querySelectorAll('.lpi__offer-card').forEach(function (c) {
  //       c.classList.remove('lpi__offer-card--selected');
  //       c.setAttribute('aria-checked', 'false');
  //     });
  //     card.classList.add('lpi__offer-card--selected');
  //     card.setAttribute('aria-checked', 'true');
  //   });
  // });

  // 9. Base setup storefront layout swatch listeners
  document.querySelectorAll('.lpi__swatch-list').forEach(function (list) {
    list.querySelectorAll('.lpi__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('lpi__swatch--sold-out')) return;

        list.querySelectorAll('.lpi__swatch').forEach(function (s) {
          s.classList.remove('lpi__swatch--active');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('lpi__swatch--active');
        btn.setAttribute('aria-pressed', 'true');

        var shade = btn.dataset.shade;
        var nameEl = btn.closest('.lpi__shades').querySelector('.lpi__selected-shade-name');
        if (nameEl) nameEl.textContent = shade;

        var variantId = btn.dataset.variantId;
        var optionIndex = parseInt(list.dataset.optionIndex, 10);

        var variantSelects = document.querySelector('variant-selects, variant-radios');
        if (variantSelects) {
          var inputs = variantSelects.querySelectorAll('[name="option' + (optionIndex + 1) + '"]');
          inputs.forEach(function (input) {
            if (input.value === shade) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          return;
        }

        if (variantId) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  });
})();

(function () {

  var FORM_SEL = window.vrProductFormId;

  function getForm()         { return document.getElementById(FORM_SEL); }
  function getSelectedCard() { return document.querySelector('.lpi__offer-card--selected'); }
  function getOfferQty(card) { return card && parseInt(card.dataset.offer, 10) === 2 ? 2 : 1; }

  function syncToForm(selectedCard) {
    var form = getForm();
    if (!form) return;

    var nativeId  = form.querySelector('input[name="id"]');
    var nativeQty = form.querySelector('input.custom-native-quantity');

    document.querySelectorAll('.lpi__free-input').forEach(function (el) {
      el.disabled = true;
    });

    if (!selectedCard) return;

    var freeInputs = selectedCard.querySelectorAll('.lpi__free-input');
    var hasFree    = freeInputs.length > 0;
    var qty        = getOfferQty(selectedCard);

    if (hasFree) {
      // if (nativeId)  nativeId.disabled  = true;
      if (nativeQty) nativeQty.value = qty;

      freeInputs.forEach(function (el) {
        el.disabled = false;
      });

      var mainIdInput = selectedCard.querySelector('.lpi__main-id-input');
      if (mainIdInput && nativeId) {
        mainIdInput.value   = nativeId.disabled ? mainIdInput.value : nativeId.value;
        mainIdInput.disabled = false;
      }

      var mainQtyInput = selectedCard.querySelector('.lpi__main-qty-input');
      if (mainQtyInput) {
        mainQtyInput.value   = qty;
        mainQtyInput.disabled = false;
      }

    } else {
      if (nativeId)  nativeId.disabled  = false;
      if (nativeQty) {
        nativeQty.disabled = false;
        nativeQty.value    = qty;
      }
    }
  }

  document.querySelectorAll('.lpi__offer-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var list = card.closest('.lpi__offer-list');
      if (!list) return;

      list.querySelectorAll('.lpi__offer-card').forEach(function (c) {
        c.classList.remove('lpi__offer-card--selected');
        c.setAttribute('aria-checked', 'false');
      });

      card.classList.add('lpi__offer-card--selected');
      card.setAttribute('aria-checked', 'true');
      syncToForm(card);
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncToForm(getSelectedCard());
  });

  document.addEventListener('variant:changed', function () {
    var form    = getForm();
    var nativeId = form ? form.querySelector('input[name="id"]') : null;
    if (!nativeId) return;

    document.querySelectorAll('.lpi__main-id-input').forEach(function (el) {
      el.value = nativeId.value;
    });
  });

})();

(function () {
  'use strict';

  var bar      = document.getElementById('sticky-atc');
  var btn      = document.getElementById('sticky-atc-btn');
  var sentinel = document.querySelector('#AddToCart, [data-product-add-to-cart-button]');

  if (!bar || !btn) return;

  function onScroll() {
  if (!sentinel) {
    window.scrollY > 400 ? show() : hide();
    return;
  }
  var rect = sentinel.getBoundingClientRect();
  rect.bottom < 0 ? show() : hide();
}

  function show() {
    bar.classList.add('satc--visible');
    bar.removeAttribute('aria-hidden');
  }

  function hide() {
    bar.classList.remove('satc--visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Spinner helpers ─────────────────────────────────── */
  function startSpinner() {
    btn.disabled = true;
    btn.classList.add('satc__btn--loading');
  }

  function stopSpinner() {
    btn.disabled = false;
    btn.classList.remove('satc__btn--loading');
  }

  /* ── Click: trigger main ATC + show spinner 4s ───────── */
  btn.addEventListener('click', function () {
    var mainBtn = document.getElementById('AddToCart');
    if (!mainBtn) return;

    startSpinner();
    mainBtn.click();

    setTimeout(function () {
      stopSpinner();
    }, 4000);
  });

})();




(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────────
     CORE UPDATE FUNCTION
     ────────────────────────────────────────────────────────────── */

  /**
   * Re-calculates and updates all `.cart__message` elements.
   * @param {Object} cart  – Shopify cart object from /cart.js or event.detail.cart
   *                         Must have `total_price` (cents) and `currency` fields.
   */
  function updateShippingBar(cart) {
    const bars = document.querySelectorAll('[data-cart-message="true"]');
    if (!bars.length) return;

    const cartTotalCents = cart.total_price;               // always in cents
    const currencyCode   = cart.currency || 'USD';

    bars.forEach(function (bar) {
      const threshold   = parseFloat(bar.dataset.limit) || 60;  // dollars
      const cartTotal   = cartTotalCents / 100;                  // cents → dollars
      const amountLeft  = Math.max(threshold - cartTotal, 0);
      const progressPct = Math.min((cartTotal / threshold) * 100, 100);
      const qualified   = amountLeft <= 0;

      const progressEl = bar.querySelector('[data-cart-message-progress]');
      if (progressEl) {
        progressEl.value = progressPct;
        progressEl.style.setProperty('--progress-width', progressPct + '%');
      }

      const leftEl = bar.querySelector('[data-left-to-spend]');
      if (leftEl) {
        //leftEl.textContent = formatMoney(amountLeft, currencyCode);
      }

      if (qualified) {
        bar.setAttribute('data-qualified', 'true');
      } else {
        bar.removeAttribute('data-qualified');
      }
    });
  }



  function formatMoney(dollars, currencyCode) {
    if (window.Intl && window.Intl.NumberFormat) {
      return new Intl.NumberFormat('en-US', {
        style:                 'currency',
        currency:              currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(dollars);
    }
    return '$' + dollars.toFixed(2) + ' ' + currencyCode;
  }



 
  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      updateShippingBar(cart);
    }
  });



  function init() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/**
 * Cart Reservation Timer
 * Counts down from 10:00. When it reaches 0:00 it automatically
 * resets and starts again from 10:00.
 *
 * Works with dynamically injected cart drawers — uses MutationObserver
 * to detect when #cartTimerCountdown appears in the DOM.
 */

/**
 * Cart Reservation Timer
 *
 * - Persists across page loads using sessionStorage (end timestamp)
 * - Survives cart drawer re-renders via MutationObserver
 * - Resets to 10:00 when countdown reaches 0:00
 */

(function () {
  'use strict';

  var TIMER_DURATION_MS = 10 * 60 * 1000;
  var STORAGE_KEY       = 'cart_reservation_end_time';
  var tickInterval      = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function getCountdownEl() {
    return document.getElementById('cartTimerCountdown');
  }

  function getEndTime() {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      var endTime = parseInt(stored, 10);
      if (endTime > Date.now()) return endTime;
    }
    return resetEndTime();
  }

  function resetEndTime() {
    var endTime = Date.now() + TIMER_DURATION_MS;
    sessionStorage.setItem(STORAGE_KEY, String(endTime));
    return endTime;
  }

  function tick() {
    var el = getCountdownEl();
    if (!el) return;

    var remaining = getEndTime() - Date.now();

    if (remaining <= 0) {
      resetEndTime();
      remaining = TIMER_DURATION_MS;
    }

    var totalSeconds = Math.ceil(remaining / 1000);
    var minutes      = Math.floor(totalSeconds / 60);
    var seconds      = totalSeconds % 60;

    // Only write to DOM if value actually changed — prevents unnecessary mutations
    var newText = minutes + ':' + pad(seconds);
    if (el.textContent !== newText) {
      el.textContent = newText;
    }
  }

  function startInterval() {
    if (tickInterval) return;
    tick();
    tickInterval = setInterval(tick, 1000);
  }

  function watchForElement() {
    var observer = new MutationObserver(function (mutations) {
      // Only act when new nodes are ADDED — ignore text/attribute changes
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) continue;

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue; // element nodes only

          // Check if the added node IS the countdown or CONTAINS it
          if (
            (node.id === 'cartTimerCountdown') ||
            (node.querySelector && node.querySelector('#cartTimerCountdown'))
          ) {
            tick(); // re-populate the freshly injected element
            break;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    getEndTime();
    startInterval();
    watchForElement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


  /* template-Smooche cart drawer progress */
(function () {
  'use strict';

  if (!document.querySelector('.template-Smooche')) {
    return;
  }

  function updateShippingBar(cart) {

    const parent = document.querySelector('.template-Smooche');

    if (!parent) return;

    const bars = parent.querySelectorAll(
      '[data-cart-message="true"]'
    );

    if (!bars.length || !cart) return;

    const cartTotalCents =
      Number(cart.total_price || 0);

    const currencyCode =
      cart.currency || 'USD';

    bars.forEach(function (bar) {

      const threshold =
        Number(bar.dataset.limit || 5000);

      const amountLeft =
        Math.max(
          threshold - cartTotalCents,
          0
        );

      const progressPct =
        Math.min(
          (cartTotalCents / threshold) * 100,
          100
        );

      const qualified =
        cartTotalCents >= threshold;

      const progressEl =
        bar.querySelector(
          '[data-cart-message-progress]'
        );

      if (progressEl) {

        progressEl.value =
          progressPct;

        progressEl.style.setProperty(
          '--progress-width',
          progressPct + '%'
        );
      }

      const leftEl =
        bar.querySelector(
          '[data-left-to-spend]'
        );

      if (leftEl) {

        leftEl.textContent =
          formatMoney(
            amountLeft / 100,
            currencyCode
          );
      }

      if (qualified) {

        bar.setAttribute(
          'data-qualified',
          'true'
        );

      } else {

        bar.removeAttribute(
          'data-qualified'
        );
      }

    });
  }

  function formatMoney(
    amount,
    currency
  ) {

    if (
      window.Intl &&
      window.Intl.NumberFormat
    ) {

      return new Intl.NumberFormat(
        'en-US',
        {
          style: 'currency',
          currency: currency
        }
      ).format(amount);

    }

    return '$' + amount.toFixed(2);
  }

  document.addEventListener(
    'cart:updated',
    function (event) {

      const cart =
        event.detail &&
        event.detail.cart;

      if (cart) {
        updateShippingBar(cart);
      }

    }
  );

  fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      updateShippingBar(cart);
    })
    .catch(function (err) {
      console.log(
        'Shipping bar error:',
        err
      );
    });

})();

document.addEventListener('DOMContentLoaded', function () {

  // Rating + Title + Price + Installments
  document.querySelectorAll('.template-Smooche .product-form, .template-Smooche-v2 .product-form')
  .forEach(parent => {

    const wrapper = document.createElement('div');
    wrapper.className = 'product-info-group';

    const items = [
      parent.querySelector('.pip__rating'),
      parent.querySelector('.pip__title-wrap'),
      parent.querySelector('.pip__price-wrap'),
      parent.querySelector('.pip__installments')
    ].filter(Boolean);

    if (items.length) {
      items[0].before(wrapper);
      items.forEach(el => wrapper.appendChild(el));
    }

  });


  // Buy button + Stock
  document.querySelectorAll('.template-Smooche .product-form, .template-Smooche-v2 .product-form')
  .forEach(parent => {

    const wrapper = document.createElement('div');
    wrapper.className = 'product-button-stock';

    const items = [
      parent.querySelector('.product-form__buy-buttons'),
      parent.querySelector('.stockinfop-content')
    ].filter(Boolean);

    if (items.length) {
      items[0].before(wrapper);
      items.forEach(el => wrapper.appendChild(el));
    }

  });


  // Derm + Description
  document.querySelectorAll('.template-Smooche .product-form, .template-Smooche-v2 .product-form')
  .forEach(parent => {

    const wrapper = document.createElement('div');
    wrapper.className = 'product-description-derm-badge';

    const items = [
      parent.querySelector('.pip__derm-badge'),
      parent.querySelector('.pip__description')
    ].filter(Boolean);

    if (items.length) {
      items[0].before(wrapper);
      items.forEach(el => wrapper.appendChild(el));
    }

  });

});

// variant click
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelector('.template-Smooche-v2 .vp-card--freebies')?.click();
//   document.querySelector('.template-luxe-v3 .vp-card--freebies')?.click();
// });

document.addEventListener('DOMContentLoaded', () => {
  const stickyButton = document.getElementById('StickyAddToCart');
  
  if (stickyButton) {
    stickyButton.addEventListener('click', function(event) {
      // On the 28 pages the sticky bar is an Add To Cart and has to behave like
      // one. Without this the preventDefault below killed the press, the lookup
      // after it came back null because those templates carry no upsell popup,
      // and nothing happened at all - the bar read "Add To Cart" and did not add.
      // Returning early lets the click reach the buy box form the button is bound
      // to, so it adds through the same handler and the same cart as the main
      // button, and its loader-button spinner runs on the way.
      //
      // Every other template keeps the behaviour it had, byte for byte, whether
      // or not it has a popup to scroll to.
      if ((' ' + document.body.className + ' ').indexOf(' template-28-') !== -1) {
        return;
      }

      event.preventDefault();
      
      const targetElement = document.querySelector('#upellPopupJs');
      
      if (targetElement) {
        targetElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'end' 
        });
      }
    });
  }
});


(function () {
  'use strict';

  var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  function decode(img, cb) {
    if (img && img.decode) { img.decode().then(cb).catch(cb); }
    else { cb(); }
  }

  // Decode the selected cell + one on each side, off the main thread.
  function decodeNeighbors(flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) return;
    var cells = flkty.cells;
    var i = flkty.selectedIndex;
    var targets = [cells[i], cells[i - 1], cells[i + 1]]
      .filter(Boolean)
      .map(function (c) { return c.element.querySelector('img'); })
      .filter(Boolean);

    (function step(n) {
      if (n >= targets.length) return;
      decode(targets[n], function () { idle(function () { step(n + 1); }); });
    })(0);
  }

  function enhance(el) {
    if (!el.flickityInstance) return;
    el.flickityInstance.then(function (flkty) {
      if (!flkty || !flkty.cells) return;

      // Preserve lazy loading for off-screen cells; decode only adjacent images.

      decodeNeighbors(flkty);                       // decode initial neighbors
      flkty.on('change', function () { decodeNeighbors(flkty); }); // and on every change

      // GPU hint only while dragging, released after — never permanent
      var vp = flkty.viewport;
      if (vp) {
        flkty.on('pointerDown', function () { vp.style.willChange = 'transform'; });
        flkty.on('settle',      function () { vp.style.willChange = 'auto'; });
      }
    });
  }

  function init() { document.querySelectorAll('flickity-carousel').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


 // Automatically empties the cart if it only contains free products.

function checkAndClearFreeCart() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) return;

      const onlyFreeProducts = cart.items.every(item => item.price === 0);

      if (onlyFreeProducts) {
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(() => {
          window.location.reload(); 
        })
        .catch(error => console.error('Error clearing cart:', error));
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

document.addEventListener('DOMContentLoaded', () => {
  checkAndClearFreeCart();
});



document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('.ingredients-section-v2 .ingredients-slider');
  if (!slider) return;

  function initSlider() {
    if (slider.classList.contains('flickity-enabled')) return;

    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: false,
      groupCells: false,
      autoPlay: false
    });

    var buttonWrap = document.querySelector('.ingredients-button');
    if (buttonWrap) {
      var prevBtn = slider.querySelector('.flickity-prev-next-button.previous');
      var nextBtn = slider.querySelector('.flickity-prev-next-button.next');
      if (prevBtn) buttonWrap.appendChild(prevBtn);
      if (nextBtn) buttonWrap.appendChild(nextBtn);
    }

    // Re-measure as any not-yet-loaded images finish
    slider.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () { flkty.resize(); });
      }
    });
  }

  initSlider();

  document.addEventListener('shopify:section:load', initSlider);
});


// Variant Picker Luxe and Smooche templates


(function () {
  window.VP = window.VP || {};

  

  /* =========================
     CART DRAWER OPENER
  ========================== */
  window.VP.openCartDrawer = function () {
    document.documentElement.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("drawer:open", { bubbles: true }));

    // Focal Robotonal API fallback
    if (window.theme && window.theme.cart && typeof window.theme.cart.openCartDrawer === "function") {
      window.theme.cart.openCartDrawer();
      return;
    }

    // DOM fallback
    const cartBtn =
      document.querySelector('[data-action="open-drawer"][href*="cart"]') ||
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector(".header__cart, .header-cart, .icon-cart");

    if (cartBtn) cartBtn.click();
  };

  /* =========================
     UPSELL POPUP TIMER
  ========================== */
  function startUpsellTimer(onExpire) {
    const timerEl = document.querySelector("[id^='upsell-timer-']");
    if (!timerEl) return;

    // Reset any existing timer
    if (window.VP.upsellState.Interval) {
      clearInterval(window.VP.upsellState.Interval);
      window.VP.upsellState.Interval = null;
    }

    timerEl.textContent = timerEl.getAttribute("data-minutes") + ":00";
    let totalSeconds = (parseInt(timerEl.getAttribute("data-minutes"), 10) || 15) * 60;

    const Interval = setInterval(() => {
      totalSeconds--;

      if (totalSeconds <= 0) {
        clearInterval(Interval);
        window.VP.upsellState.Interval = null;
        timerEl.textContent = "00:00";
        if (typeof onExpire === "function") onExpire();
        return;
      }

      const m = Math.floor(totalSeconds / 60);
      const s = totalSeconds % 60;
      timerEl.textContent = (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
    }, 1000);

    window.VP.upsellState.Interval = Interval;
  }

  /* =========================
     BUILD MAIN + FREEBIE ITEMS
  ========================== */
    function buildMainItems() {
      const state = window.VP.upsellState;
      const items = [];
      const gifts = [];
      const planEl = document.querySelector('[data-auto-selling-plan]');
      const sellingPlan = planEl ? Number(planEl.dataset.autoSellingPlan) : null;

      let mainItem = null;

      if (state.mainVariantId) {
        const properties = {};

        document.querySelectorAll('.vp-freebie-input[name^="properties["]').forEach(input => {
          if (input.disabled) return;

          const match = input.name.match(/properties\[([^\]]+)\]/);
          if (match) {
            properties[match[1]] = input.value;
          }
        });

        const selectedInput = document.querySelector('.vp-radio-input:checked');
        const quantity = selectedInput ? parseInt(selectedInput.dataset.quantity) : 1;

        mainItem = {
          id: Number(state.mainVariantId),
          quantity
        };

        if (sellingPlan) {
          console.log(sellingPlan);
          mainItem.selling_plan = sellingPlan;
        }

        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties;
        }
      }

      // Collect gifts
      document.querySelectorAll('.vp-freebie-input[name="items[][id]"]').forEach(input => {
        if (input.disabled) return;

        const variantId = Number(input.value);
        if (!variantId) return;

        gifts.push({
          id: variantId,
          quantity: 1
        });
      });

      // Reverse gifts
      gifts.reverse();

      // Gifts first
      items.push(...gifts);

      // Main product last
      if (mainItem) {
        items.push(mainItem);
      }

      return items;
    }

  /* =========================
     ADD MAIN + FREEBIES ONLY (no upsell)
  ========================== */
  function addMainProductsOnly() {
    const items = buildMainItems();
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    }).then(res => res.json());
  }

  function addItemsAndRefresh(items, onSuccess, onError) {

      let sectionName = 'mini-cart-new';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, sections: [sectionName] })
      })
      .then(r => r.json())
      .then(addData => {
        if (addData.status === 422) {
          throw new Error(addData.message || 'Sold out');
        }

        // Fetch cart data
        return fetch('/cart.js')
          .then(r => r.json())
          .then(cartContent => {
            cartContent['sections'] = addData['sections'];

            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent }
            }));

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: false 
              }
            }));

            return cartContent;
          });
      })
      .then(cartContent => {
        if (typeof onSuccess === 'function') onSuccess(cartContent);
      })
      .catch(err => {
        console.error('Cart error:', err);
        if (typeof onError === 'function') onError(err);
      });
  }

  /* =========================
     HANDLE MAIN ONLY ADD + OPEN DRAWER
  ========================== */
  function handleMainOnlyAdd() {
      const state = window.VP.upsellState;
      if (!state.mainVariantId) return;

      if (state.interval) {
        clearInterval(state.interval);
        state.interval = null;
      }

      const items = buildMainItems();
      const overlay = document.querySelector(".upsell-overlay");
      const declineBtn = document.querySelector(".upsell-decline-btn");

      addItemsAndRefresh(
        items,
        function onSuccess() {
          if (overlay) overlay.style.display = "none";
            window.VP.openCartDrawer();
            if (declineBtn) {
              declineBtn.dataset.loading = "false";
              declineBtn.disabled = false;
            }
         
        },
        function onError() {
          if (declineBtn) {
            declineBtn.dataset.loading = "false";
            declineBtn.disabled = false;
          }
        }
      );
   }


  /* =========================
     ADD TO CART BUTTON — OPEN UPSELL POPUP
  ========================== */
  document.addEventListener("click", function (e) {
    const addToCartBtn = e.target.closest("#upellPopupJs");
    if (!addToCartBtn) return;

    e.preventDefault();
    e.stopPropagation();
    document.documentElement.classList.add('lock-all');

    const overlay = document.querySelector(".upsell-overlay");
    if (!overlay) return;

    const wrap = document.querySelector(".vp-wrap");
    const mainInput = wrap ? wrap.querySelector('input[name="id"]:checked') : null;

    window.VP.upsellState.mainVariantId = mainInput ? mainInput.value : null;
    window.VP.upsellState.timerExpired = false;

    overlay.style.display = "flex";

    // On timer expire, add main product only
    startUpsellTimer(function () {
      handleMainOnlyAdd();
    });
  });

  /* =========================
     UPSELL ADD BUTTON — ADD MAIN + UPSELL
  ========================== */
   document.addEventListener("click", function (e) {
    const btn = e.target.closest(".upsell-add-btn");
    if (!btn) return;

    e.preventDefault();

    const upsellVariantId = btn.getAttribute("data-variant-id");
    const mainVariantId = window.VP.upsellState.mainVariantId;

    if (!upsellVariantId || !mainVariantId) {
      console.warn("Missing variant IDs", { upsellVariantId, mainVariantId });
      return;
    }

    if (btn.dataset.loading === "true") return;
    btn.dataset.loading = "true";
    btn.disabled = true;

    if (window.VP.upsellState.interval) {
      clearInterval(window.VP.upsellState.interval);
      window.VP.upsellState.interval = null;
    }

    const items = buildMainItems();

    const upsellItem = {
      id: Number(upsellVariantId),
      quantity: 1
    };

    items.splice(Math.max(items.length - 1, 0), 0, upsellItem);

    addItemsAndRefresh(
      items,
      function onSuccess() {
        const overlay = document.querySelector(".upsell-overlay");
        if (overlay) overlay.style.display = "none";
        setTimeout(() => {
          window.VP.openCartDrawer();
          btn.dataset.loading = "false";
          btn.disabled = false;
        }, 150);
      },
      function onError() {
        // Upsell failed — fallback to main only
        console.warn("Upsell failed, trying main only");
        addItemsAndRefresh(
          buildMainItems(),
          function() {
            const overlay = document.querySelector(".upsell-overlay");
            if (overlay) overlay.style.display = "none";
              window.VP.openCartDrawer();
              btn.dataset.loading = "false";
              btn.disabled = false;
          },
          function() {
            btn.dataset.loading = "false";
            btn.disabled = false;
          }
        );
      }
    );
  });

  /* =========================
     CLOSE BUTTON — ADD MAIN ONLY
  ========================== */
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".upsell-close-btn")) return;
    const btn = document.querySelector(".upsell-decline-btn");
    e.preventDefault();
     // Prevent double click
    if (btn) {
      btn.dataset.loading = "true";
      btn.disabled = true;
    }
    handleMainOnlyAdd();
  });

  /* =========================
     DECLINE BUTTON — ADD MAIN ONLY
  ========================== */
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".upsell-decline-btn")) return;
    const btn = e.target.closest(".upsell-decline-btn ");
    e.preventDefault();
     // Prevent double click
    if (btn.dataset.loading === "true") return;
    btn.dataset.loading = "true";
    btn.disabled = true;
    handleMainOnlyAdd();
  });

  /* =========================
     FREEBIE AUTO-REMOVE
     Freebies are linked to 2nd variant (2 bottle).
     When 2 bottle is removed, freebies are removed too.
  ========================== */

$(document).ready(function() {

  function updateATCComparePrice($input) {
    const comparePrice = $input.attr('data-compare-price');
    console.log('compare price:', comparePrice);
    if (!comparePrice) return;
    $('#upellPopupJs .buy-button-compare-price').text(comparePrice);
  }

  // Use click on label instead of change on input
  $(document).on('click', '.vp-card', function() {
    const $input = $(this).find('.vp-radio-input');
    console.log('card clicked, option:', $input.attr('data-option'));
    updateATCComparePrice($input);
  });

  // On page load
  const $checked = $('.vp-radio-input:checked');
  if ($checked.length) updateATCComparePrice($checked);

});

})(); // IIFE closing



// end of Variant Picker Luxe and Smooche templates



// cart Drawer Upsells JS

(function () {
        'use strict';

        /* ── Swatch click ── */
        document.addEventListener('click', function (e) {
          var swatch = e.target.closest('.upsell-swatch');
          if (!swatch) return;

          var productId = swatch.dataset.productId;
          var card = document.querySelector('[data-upsell-product="' + productId + '"]');
          if (!card) return;

          /* 1. Active state */
          card.querySelectorAll('.upsell-swatch').forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');

          /* 2. Update variant id in form */
          var variantInput = card.querySelector('input[data-variant-id="' + productId + '"]');
          if (variantInput) variantInput.value = swatch.dataset.variantId;

          /* 3. Update prices */
          var priceEl = card.querySelector('[data-upsell-price="' + productId + '"]');
          var compareEl = card.querySelector('[data-upsell-compare-price="' + productId + '"]');
          if (priceEl) priceEl.textContent = swatch.dataset.variantPrice;
          if (compareEl) {
            if (swatch.dataset.variantCompare && swatch.dataset.variantCompare !== swatch.dataset.variantPrice) {
              compareEl.textContent = swatch.dataset.variantCompare;
              compareEl.style.display = 'inline';
            } else {
              compareEl.style.display = 'none';
            }
          }

          /* 4. Swap image with fade */
          var imgEl = card.querySelector('[data-upsell-image="' + productId + '"]');
          var newSrc = swatch.dataset.variantImage;
          if (imgEl && newSrc) {
            imgEl.style.opacity = '0';
            imgEl.src = newSrc;
            imgEl.onload = function () {
              imgEl.style.opacity = '1';
            };
            imgEl.onerror = function () {
              imgEl.style.opacity = '1';
            };
          }
        });

        /* ── Add to cart ── */
        document.addEventListener('submit', function (e) {
          var form = e.target.closest('.cart-upsell-form');
          if (!form) return;
          e.preventDefault();

          var btn = form.querySelector('.product-upsell__btn');
          var variantId = form.querySelector('[name="id"]').value;
          var variantQty = form.querySelector('[name="quantity"]').value;

          btn.classList.add('is-loading');
          btn.textContent = 'Adding\u2026';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: variantQty }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('failed');
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              btn.textContent = 'Added \u2713';
              setTimeout(function () {
                btn.classList.remove('is-added');
                btn.textContent = 'Add to Cart';
              }, 2000);
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            })
            .catch(function () {
              btn.classList.remove('is-loading');
              btn.textContent = 'Error \u2013 try again';
              setTimeout(function () {
                btn.textContent = 'Add to Cart';
              }, 2500);
            });
        });
      })();


// End cart Drawer Upsells JS


async function clearZeroValueCart(cart) {
  if (!cart) return;

  if (window.__clearingZeroValueCart) return;

  if (cart.total_price === 0 && cart.item_count > 0) {
    window.__clearingZeroValueCart = true;

    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );

      // window.location.reload();
    } catch (error) {
      console.error("Failed to clear zero-value cart:", error);
      window.__clearingZeroValueCart = false;
    }
  }
}

document.addEventListener("cart:updated", function (event) {
  clearZeroValueCart(event.detail.cart);
});

document.addEventListener("DOMContentLoaded", async function () {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    clearZeroValueCart(cart);
  } catch (error) {
    console.error("Failed to fetch cart:", error);
  }
});


(function () {
  'use strict';

  var GIFT_PROPERTY_PATTERN = /^_free[\s_-]*gift(?:[\s_-]*\d+)?$/i;
  var GIFT_ID_INPUT_SELECTOR = 'input.freegiftId';
  var GIFT_QUANTITY = 1;
  var ORPHAN_ZERO_PRICED = true;
  var CLEAR_ORPHANED_GIFT_CART = true;
  var REGISTRY_KEY = 'cart-gifts:variants';
  var RELOAD_KEY = 'cart-gifts:reloads';
  var MAX_RETRIES = 2;
  var RETRY_DELAY = 800;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_PATH = (ROOT + 'cart').replace(/\/{2,}/g, '/').replace(/\/+$/, '');

  var knownGifts = new Set();
  var reconciling = false;
  var suppressListener = false;
  var lastPlan = null;
  var repeats = 0;
  var queue = Promise.resolve();

  try {
    JSON.parse(sessionStorage.getItem(REGISTRY_KEY) || '[]').forEach(function (id) {
      knownGifts.add(id);
    });
  } catch (e) {}

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function qty(value) {
    var n = parseInt(value, 10);
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function isCartPage() {
    return window.location.pathname.replace(/\/+$/, '') === CART_PATH;
  }

  function isGiftId(value) {
    var id = value == null ? '' : String(value).trim();
    return /^\d+$/.test(id) && id !== '0';
  }

  function giftIdsOf(item) {
    var props = (item && item.properties) || {};
    return Object.keys(props)
      .filter(function (key) { return GIFT_PROPERTY_PATTERN.test(key) && isGiftId(props[key]); })
      .map(function (key) { return String(props[key]).trim(); });
  }

  function remember(id) {
    if (!isGiftId(id)) return;
    id = String(id).trim();
    if (knownGifts.has(id)) return;
    knownGifts.add(id);
    try {
      sessionStorage.setItem(REGISTRY_KEY, JSON.stringify(Array.from(knownGifts)));
    } catch (e) {}
  }

  function rememberFromDom($scope) {
    ($scope || $(document)).find(GIFT_ID_INPUT_SELECTOR).each(function () {
      remember($(this).val());
    });
  }

  function rememberFromCart(cart) {
    ((cart && cart.items) || []).forEach(function (item) {
      giftIdsOf(item).forEach(remember);
    });
  }

  function postJSON(url, payload, attempt) {
    attempt = attempt || 0;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) return res.json();
      if (res.status >= 500 && attempt < MAX_RETRIES) {
        return sleep(RETRY_DELAY).then(function () { return postJSON(url, payload, attempt + 1); });
      }
      throw new Error('Cart request failed (' + res.status + ')');
    });
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateCart(updates) {
    return postJSON(ROOT + 'cart/update.js', { updates: updates });
  }

  function addToCart(items) {
    return postJSON(ROOT + 'cart/add.js', { items: items });
  }

  function clearCart() {
    return postJSON(ROOT + 'cart/clear.js', {});
  }

  function isGiftLine(item, owed) {
    if (giftIdsOf(item).length > 0) return false;
    if (item.properties && item.properties._bio_bonus_pack === 'true') return true;
    if (owed.has(String(item.variant_id))) return true;
    if (item.final_line_price !== 0 && item.price !== 0) return false;
    var id = String(item.variant_id);
    return knownGifts.has(id) || owed.has(id) || ORPHAN_ZERO_PRICED;
  }

  function planReconciliation(cart) {
    var items = (cart && cart.items) || [];
    var owed = new Set();
    var bioBonusQuantities = new Map();
    items.forEach(function (item) {
      var properties = item.properties || {};
      var id = String(properties._bio_bonus_variant || '');
      var quantity = Number(properties._bio_bonus_quantity);
      if (/^\d+$/.test(id) && (quantity === 1 || quantity === 2)) {
        remember(id);
        owed.add(id);
        bioBonusQuantities.set(id, (bioBonusQuantities.get(id) || 0) + quantity * item.quantity);
      }
    });

    items.forEach(function (item) {
      giftIdsOf(item).forEach(function (id) {
        remember(id);
        owed.add(id);
      });
    });

    var updates = {};
    var present = new Set();

    items.forEach(function (item) {
      if (!isGiftLine(item, owed)) return;
      var id = String(item.variant_id);
      var target = !present.has(id) && owed.has(id) ? (bioBonusQuantities.get(id) || GIFT_QUANTITY) : 0;
      present.add(id);
      if (item.quantity !== target) updates[item.key] = target;
    });

    var additions = [];
    owed.forEach(function (id) {
      if (!present.has(id)) additions.push({ id: Number(id), quantity: bioBonusQuantities.get(id) || GIFT_QUANTITY });
    });

    return { updates: updates, additions: additions, owed: owed };
  }

  function reconcile(cart) {
    if (reconciling) return Promise.resolve(cart);

    var plan = planReconciliation(cart);
    if (!Object.keys(plan.updates).length && !plan.additions.length) {
      lastPlan = null;
      repeats = 0;
      try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
      return Promise.resolve(cart);
    }

    var signature = JSON.stringify([plan.updates, plan.additions]);
    if (signature === lastPlan && ++repeats >= 2) {
      console.warn('[cart-gifts] cart will not converge', plan);
      return Promise.resolve(cart);
    }
    if (signature !== lastPlan) {
      lastPlan = signature;
      repeats = 0;
    }

    reconciling = true;
    return (plan.additions.length ? addToCart(plan.additions) : Promise.resolve(cart))
      .then(function (next) {
        return Object.keys(plan.updates).length ? updateCart(plan.updates) : next;
      })
      .then(function (next) { return next || cart; })
      .finally(function () { reconciling = false; });
  }

  function isOrphanedGiftCart(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return false;
    return items.every(function (item) {
      return giftIdsOf(item).length === 0 && (item.final_line_price === 0 || item.price === 0);
    });
  }

  function settle(cart) {
    return reconcile(cart).then(function (next) {
      if (!CLEAR_ORPHANED_GIFT_CART || !isOrphanedGiftCart(next)) return next;
      return clearCart();
    });
  }

  function canReload() {
    if (!isCartPage()) return true;
    var used = parseInt(sessionStorage.getItem(RELOAD_KEY), 10) || 0;
    if (used >= 2) return false;
    try { sessionStorage.setItem(RELOAD_KEY, String(used + 1)); } catch (e) {}
    return true;
  }

  function publish(cart) {
    if (isCartPage()) {
      if (canReload()) window.location.reload();
      return;
    }
    suppressListener = true;
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
    );
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () { suppressListener = false; }, 0);
  }

  function enqueue(task) {
    queue = queue.then(task, task).catch(function (error) {
      console.error('[cart-gifts]', error);
    });
    return queue;
  }

  function setQuantity(lineKey, quantity) {
    var updates = {};
    updates[lineKey] = qty(quantity);
    return updateCart(updates)
      .then(settle)
      .then(function (cart) { publish(cart); return cart; });
  }

  function sync() {
    return enqueue(function () {
      return getCart().then(function (cart) {
        rememberFromCart(cart);
        return settle(cart).then(function (next) {
          if (next !== cart) publish(next);
          return next;
        });
      });
    });
  }

  function lock($line, locked) {
    $line.toggleClass('is-updating', locked)
      .find('.quantity-selector__button, .link.main-product--true')
      .prop('disabled', locked);
  }

  function lineKeyOf($el, $line) {
    return $el.attr('data-line-id') || $line.attr('data-line-id') || '';
  }

  $(document).on('click', '.quantity-selector__button.plus, .quantity-selector__button.minus', function (event) {
    event.preventDefault();

    var $button = $(this);
    if ($button.prop('disabled')) return;

    var $line = $button.closest('.line-item');
    var $input = $line.find('.quantity-selector__input').first();
    var lineKey = lineKeyOf($button, $line);
    if (!lineKey) return;

    rememberFromDom($line);

    var current = qty($input.val());
    var next = Math.max(0, current + ($button.hasClass('plus') ? 1 : -1));
    if (next === current) return;

    $input.val(next);
    lock($line, true);

    enqueue(function () {
      return setQuantity(lineKey, next)
        .catch(function (error) { $input.val(current); throw error; })
        .finally(function () { lock($line, false); });
    });
  });

  $(document).on('click', '.link.main-product--true', function (event) {
    event.preventDefault();

    var $link = $(this);
    if ($link.prop('disabled')) return;

    var $line = $link.closest('.line-item');
    var lineKey = lineKeyOf($link, $line);
    if (!lineKey) return;

    rememberFromDom($line);
    lock($line, true);

    enqueue(function () {
      return setQuantity(lineKey, 0).finally(function () { lock($line, false); });
    });
  });

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (suppressListener || reconciling) return;

    var cart = event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;

    rememberFromCart(cart);
    enqueue(function () {
      return settle(cart).then(function (next) {
        if (next !== cart) publish(next);
      });
    });
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(function () { rememberFromDom(); }, 0);
  });

  $(function () {
    rememberFromDom();
    sync();
  });

  window.CartGifts = { sync: sync, plan: planReconciliation };
  window.checkAndAddFreeProducts = sync;
  window.cartUpdated = function (payload) {
    var updates = (payload && payload.updates) || payload || {};
    return enqueue(function () {
      return updateCart(updates)
        .then(settle)
        .then(function (cart) { publish(cart); return cart; });
    });
  };
})();


window.addEventListener('load', () => {
  if (typeof Flickity === 'undefined') return;
  document.querySelectorAll('.product__media-list').forEach(el => {
    const f = Flickity.data(el);
    if (f) f.resize();
  });
});